import { createSignal, onMount, createEffect, Show, on, untrack, onCleanup, For } from "solid-js";
import { useActiveManeuverViewMirror } from "../../../../store/activeManeuverViewStore";
import { createMemo } from "solid-js";

import DropDownButton from "../../../../components/buttons/DropDownButton";

import DataTable_Big from "../../../../components/maneuvers/standard/DataTable_Big";
import DataTable_Small from "../../../../components/maneuvers/standard/DataTable_Small";
import ManeuverMap from "../../../../components/maneuvers/standard/Map";
import Scatter from "../../../../components/maneuvers/standard/Scatter";
import TimeSeries, { MAP_SIDE_PANEL_EXTRA_HEIGHT_PX, MAP_SIDE_PANEL_BUTTON_GAP_PX } from "../../../../components/maneuvers/standard/TimeSeries";
import DataTable_BigGrouped from "../../../../components/maneuvers/grouped/DataTable_Big";
import DataTable_SmallGrouped from "../../../../components/maneuvers/grouped/DataTable_Small";
import MapGrouped from "../../../../components/maneuvers/grouped/Map";
import ScatterGrouped from "../../../../components/maneuvers/grouped/Scatter";
import TimeSeriesGrouped from "../../../../components/maneuvers/grouped/TimeSeries";
import ScatterTimeseries from "../../../../components/charts/ScatterTimeseries";
import LiveManeuversPollStatus from "./LiveManeuversPollStatus";
import * as d3 from "d3";

import { setupMediaContainerScaling } from "../../../../utils/global";
import { logPageLoad, logActivity, getCurrentProjectDatasetIds } from "../../../../utils/logging";
import { error as logError, debug as logDebug, info as logInfo } from "../../../../utils/console";

import { phase, setPhase, color, setColor, tws, setTws, eventType, setEventType, grouped, groupDisplayMode, setGroupDisplayMode, maneuvers, setManeuvers, setTableData, setFiltered, filtered, tabledata, maneuverTableSort, setManeuverTableSort } from "../../../../store/globalStore";
import { sortManeuverRows } from "../../../../utils/maneuverTableSort";
import { selectedEvents, setSelectedEvents, setLegendSelectionActive, setTriggerUpdate, setTriggerSelection, setSelection, selection, hasSelection, isCut, cutEvents, hideSelectedEvents, selectedGroupKeys, setSelectedGroupKeys, setHasSelection, clearSelection, cutSelection, setLiveHighlightEvents, liveHighlightEvents, highlightedEventIds } from "../../../../store/selectionStore";
import { liveManeuverFollow, liveManeuverFollowActive, setLiveManeuverFollow, liveMode, setLiveMode, clearManeuverPlayhead } from "../../../../store/playbackStore";
import LiveFollowToggle from "../../../../components/utilities/LiveFollowToggle";

import { persistantStore } from "../../../../store/persistantStore";
import { sourcesStore } from "../../../../store/sourcesStore";
import { streamingStatusStore } from "../../../../store/streamingStatusStore";
import { apiEndpoints } from "@config/env";
import { getData, getEventTimes, formatDateTime } from "../../../../utils/global";
import { runEventTimesSelectionSync } from "../../../../utils/eventTimesSelection";
import { ensureLiveDatasetsForProject } from "../../../../utils/liveDatasets";
import ManeuverSettings from "../../../../components/menus/ManeuverSettings";
import PerformanceFilterSummary from "../../../../components/legends/PerformanceFilterSummary";
import {
  getStoredLiveManeuverSelectionSources,
  setStoredLiveManeuverSelectionSources,
} from "../../../../utils/liveManeuverSelectionSources";
import { loadSharedSourceIds, sourceIdsFromNames } from "../../../../utils/liveSourcePersistence";
import { initializeSourceSelections } from "../../../../utils/sourceInitialization";
import { debug } from "../../../../utils/console";
import { useDashboardShareRestore } from "../../../../hooks/useDashboardShareRestore";
import { buildManeuversShareState, applyManeuversShareState } from "../../../../utils/reportShareState";
import {
  setSelectedGradesManeuvers,
  setSelectedStatesManeuvers,
  setSelectedRacesManeuvers,
  setSelectedLegsManeuvers,
  maneuverTrainingRacing,
  setManeuverTrainingRacing,
  maneuverTackEntry,
  setManeuverTackEntry,
  raceOptions as storeRaceOptions,
  legOptions as storeLegOptions,
  gradeOptions as storeGradeOptions,
  setRaceOptions as pushRaceOptionsToFilterStore,
  setLegOptions as pushLegOptionsToFilterStore,
  setGradeOptions as pushGradeOptionsToFilterStore,
  selectedSources as sharedSelectedSources,
} from "../../../../store/filterStore";
import { setCurrentDataset, getCurrentDatasetTimezone } from "../../../../store/datasetTimezoneStore";
import { getGroupKeyFromItem, groupKeyEquals, legendTextToGroupKeyTable, toggleGroupKeyInList } from "../../../../utils/colorGrouping";
import { TAKEOFF_CHANNELS, ACCELERATION_ACCMAX_CHANNELS, ACCELERATION_BUILD_VMG_CHANNELS, RIDE_HEIGHT_CHANNELS, buildManeuversChannelsRequest } from "../../../../utils/maneuversConfig";
import {
  mapManeuverRowsToScatterTimeseriesPoints,
  maneuverTimelineLegendGroups,
} from "../../../../utils/maneuverScatterTimeseries";
import ManeuverColorLegend from "../../../../components/legends/ManeuverColorLegend";
import {
  buildManeuverColorLegendItems,
  applyManeuverLegendSelection,
} from "../../../../utils/maneuverColorLegend";
import { maneuverColorLegendReservePx } from "../../../../utils/maneuverLegendHeight";
import { applyManeuverEntrySide } from "../../../../utils/maneuverTackEntryFilter";
import { normalizeManeuverEventType } from "../../../../utils/maneuverEventType";
import { clearManeuverSelectionOnEventTypeChange } from "../../../../utils/maneuverEventTypeSelection";
import { useOpenGradeAllForMapClick } from "../../../../utils/maneuverMapClickGrade";
import { passesManeuverRaceFilter, passesManeuverTrainingRacingFilter } from "../../../../utils/maneuverRaceFilter";
import {
  reconcileManeuverStateSelection,
  reconcileManeuverStatesWithBaseline,
} from "../../../../utils/maneuverFoilingState";
import { fetchFleetDayManeuverStateOptions } from "../../../../utils/maneuverStateOptionsService";
import { persistentSettingsService, type PersistentSettings } from "../../../../services/persistentSettingsService";
import { user } from "../../../../store/userStore";
import {
  LIVE_REPORT_WINDOW_DEFAULT_MINUTES,
  liveReportWindowStartIso,
  liveReportWindowStartMs,
  normalizeLiveReportWindowMinutes,
} from "../../../../utils/liveReportTimeWindow";
import {
  LIVE_ALL_GRID_MANEUVER_TYPES,
  LIVE_MANEUVER_SOLO_VIEWS,
  normalizeLiveManeuverEventType,
  normalizeLiveSoloView,
  getManeuverRowSourceName,
  getManeuverRowEventType,
  getManeuverRowTimeMs,
  latestEventIdsBySource,
  partitionRowsByLiveGridType,
} from "../../../../utils/liveManeuverSelection";
import {
  registerLiveManeuverUpdateGate,
  unregisterLiveManeuverUpdateGate,
} from "../../../../utils/liveManeuverUpdateGate";
import { createLivePollCoordinator } from "../../../../utils/liveManeuverPollCoordinator";
import { shouldForceReleaseLiveLoop, resolveLiveStallThresholdMs, LIVE_STALL_CHECK_MS } from "../../../../utils/liveStallWatchdog";
import { isLivePageActive } from "../../../../utils/liveScope";
import { setLiveReportEdge, clearLiveReportEdge } from "../../../../store/liveReportEdgeStore";
import {
  liveConfigStore,
  fetchLiveConfig,
  syncLiveConfigFromStatus,
} from "../../../../store/liveConfigStore";

const { selectedClassName, selectedProjectId, selectedDate, selectedDatasetId, setSelectedDate } = persistantStore;

// Channels list for maneuvers endpoints - matches single-source Maneuvers / ManeuversHistory (incl. drop columns)
const MANEUVERS_CHANNELS = [
  'Tws_bin',
  'Tws_avg',
  'Twa_entry',
  'Twa_entry_n',
  'Vmg_perc_avg',
  'Loss_inv_tgt',
  'Loss_turn_tgt',
  'Loss_build_tgt',
  'Loss_total_tgt',
  'Mmg',
  'Bsp_drop',
  'Bsp_min',
  'Bsp_min_delta',
  'Drop_time',
  'Pop_time',
  'Time_two_boards',
  'Raise_time',
  'Accel_slope',
  'Decel_slope',
  'Lwy_max',
  'Turn_radius',
  'Accel_max',
  'Accel_min',
  'Twa_exit_n',
  'Twa_build_n',
  'Twa_drop_n',
  'Turn_rate_max',
  'Turn_angle_max',
  'Overshoot_angle',
  'Overshoot_perc',
  'Time_raising',
  'Time_dropping',
  'Rud_ang_max',
  'Twd_delta',
  'Rake_drop',
  'Aoa_drop',
  'Heel_drop',
  'Rake_aoa_min_old_turn',
  'Aoa_raise',
  'Pitch_raise',
  'Heel_lock',
  'Rake_min_old_turn',
  'Rake_max_new_turn',
  'Rake_removed_old_time_turn',
  'Rake_added_new_time_turn',
  'Cant_drop_tgt',
  ...ACCELERATION_BUILD_VMG_CHANNELS,
  ...ACCELERATION_ACCMAX_CHANNELS,
  ...RIDE_HEIGHT_CHANNELS,
];

const LIVE_MANEUVERS_PAGE_KEY = 'LiveManeuvers';
const DEFAULT_LIVE_MANEUVER_POLL_MS = 10_000;
const STREAMING_STATUS_MAX_AGE_MS = 45_000;
/** Limit parallel maneuver API calls so opening Live Maneuvers does not starve the live map thread. */
const LIVE_MANEUVER_FETCH_CONCURRENCY = 4;

async function runWithConcurrency<T>(
  tasks: Array<() => Promise<T>>,
  limit: number
): Promise<T[]> {
  if (tasks.length === 0) return [];
  const results: T[] = new Array(tasks.length);
  let nextIndex = 0;
  const workerCount = Math.min(Math.max(1, limit), tasks.length);
  await Promise.all(
    Array.from({ length: workerCount }, async () => {
      while (nextIndex < tasks.length) {
        const idx = nextIndex++;
        results[idx] = await tasks[idx]();
      }
    })
  );
  return results;
}

type LiveManeuverFetchCache = { key: string; rows: unknown[] };
let liveManeuverFetchCache: LiveManeuverFetchCache | null = null;
let liveManeuverFetchCacheAt = 0;
const LIVE_NEW_ROW_HIGHLIGHT_MS = 4_000;
const DEFAULT_LIVE_MANEUVER_EVENT_TYPE = 'TACK';
const LIVE_MAP_ALL_PAGE_KEY = 'LiveMapAllManeuvers';
/** Grade pills in Maneuver Settings (All, >1, >2) — set on mount so modal is usable before first fetch. */
const LIVE_MANEUVER_GRADE_OPTIONS: number[] = [-1, 1, 2];
/** Baseline foiling states until live discovery returns rows from the API. */
const LIVE_MANEUVER_DEFAULT_STATE_OPTIONS: string[] = ['H0', 'H1', 'H2'];

type LiveManeuverSavedFilters = NonNullable<PersistentSettings['maneuverFilters']>;
let cachedPersistentManeuverFilters: LiveManeuverSavedFilters | null = null;

/** Wall-clock session date for LIVE dataset rows (matches server_stream UTC date). */
function getLiveSessionDateYmd(): string {
  const d = new Date();
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Prefer LIVE context date from store (dataset row / handleSelectLive), not UTC override. */
function getLiveManeuverQueryDateYmd(): string {
  const fromStore = (selectedDate() || '').trim();
  if (fromStore && fromStore !== '0') {
    return fromStore;
  }
  return getLiveSessionDateYmd();
}

export interface LiveManeuversPageProps {
  mapAllOnly?: boolean;
  soloView?: string;
}

export default function LiveManeuversPage(props: LiveManeuversPageProps = {}) {
  let mediaContainerRef: HTMLDivElement | undefined;
  const mapAllOnly = () => props.mapAllOnly === true;
  const soloViewName = createMemo(() => normalizeLiveSoloView(props.soloView || ''));
  const soloMode = () => mapAllOnly() || soloViewName() != null;

  // Use fleet context for this component
  const context = 'fleet';

  const [eventTypes] = createSignal<string[]>(['TACK', 'GYBE', 'ROUNDUP', 'BEARAWAY', 'TAKEOFF']);
  const liveAllGridData = createMemo(() => {
    if (!mapAllOnly()) return null;
    return partitionRowsByLiveGridType(tabledata() as Record<string, unknown>[]);
  });
  const [phases] = createSignal<string[]>(['FULL', 'INVESTMENT', 'TURN', 'ACCELERATION']);
  // Fleet context. Tack is derived from TWA on each row; crew comes from tags->>'CREW_CODE'.
  const [colors] = createSignal<string[]>(['SOURCE', 'TACK', 'CONFIG', 'CREW', 'STATE', 'EVENT', 'TESTS']);
  const [grades] = createSignal<string[]>(['ALL', '> 1', '1', '2', '3']);
  const [twsoptions, setTwsOptions] = createSignal<string[]>([]);

  const [views] = createSignal<string[]>(['MAP', 'TABLE', 'SCATTER', 'TIME SERIES']);
  const [view, setView] = createSignal<'MAP' | 'TABLE' | 'SCATTER' | 'TIME SERIES'>('MAP');
  useActiveManeuverViewMirror(view);
  // MAP mode: toggle the left column between the data table and a playhead-synced timeseries whose
  // drag moves a boat on the map. Ephemeral — reset back to TABLE whenever we leave MAP.
  const [mapSidePanel, setMapSidePanel] = createSignal<'TABLE' | 'CHART'>('TABLE');
  createEffect(on(view, (v) => { if (v !== 'MAP') { setMapSidePanel('TABLE'); clearManeuverPlayhead(); } }));
  // highlightedEventIds(), not selectedEvents(): in follow mode the maneuvers being shown come from
  // the live auto-highlight, which is deliberately outside the selection store. Gating on the manual
  // selection alone left the chart panel unreachable (and instantly reverted) during normal live use.
  createEffect(() => { if (mapSidePanel() === 'CHART' && highlightedEventIds().length === 0) { setMapSidePanel('TABLE'); } });
  const [groupedOptions] = createSignal<string[]>(['OFF', 'ON', 'MIX']);
  const [scatterKey, setScatterKey] = createSignal<number>(0);

  // State for ManeuverSettings
  const [raceOptions, setRaceOptions] = createSignal<(number | string)[]>([]);
  const [legOptions, setLegOptions] = createSignal<number[]>([]);
  const [gradeOptions, setGradeOptions] = createSignal<number[]>(LIVE_MANEUVER_GRADE_OPTIONS);
  const [stateOptions, setStateOptions] = createSignal<string[]>([...LIVE_MANEUVER_DEFAULT_STATE_OPTIONS]);
  const [selectedRaces, setSelectedRaces] = createSignal<(number | string)[]>([]);
  const [selectedLegs, setSelectedLegs] = createSignal<number[]>([]);
  const [selectedGrades, setSelectedGrades] = createSignal<number[]>([]);
  const [selectedStates, setSelectedStates] = createSignal<string[]>([]);

  const applyLiveManeuverFilterDefaults = () => {
    setSelectedGrades([0]);
    setSelectedGradesManeuvers(['0']);
    setSelectedStates([]);
    setSelectedStatesManeuvers([]);
    setSelectedRaces([]);
    setSelectedLegs([]);
    setSelectedRacesManeuvers([]);
    setSelectedLegsManeuvers([]);
    setManeuverTrainingRacing(null);
    ensureLiveManeuverFilterOptionBaselines();
  };

  const applyManeuverFiltersFromSettings = (filters: LiveManeuverSavedFilters | null | undefined): boolean => {
    if (!filters) return false;

    let applied = false;
    if (filters.grades && Array.isArray(filters.grades) && filters.grades.length > 0) {
      setSelectedGrades(filters.grades);
      setSelectedGradesManeuvers(filters.grades.map((g: number) => String(g)));
      applied = true;
    }
    if (filters.states && Array.isArray(filters.states)) {
      setSelectedStates(filters.states);
      setSelectedStatesManeuvers(filters.states);
      applied = true;
    }
    if (filters.races && Array.isArray(filters.races) && filters.races.length > 0) {
      setSelectedRaces(filters.races);
      setSelectedRacesManeuvers(filters.races.map((r: number | string) => String(r)));
      applied = true;
    }
    if (filters.legs && Array.isArray(filters.legs) && filters.legs.length > 0) {
      setSelectedLegs(filters.legs);
      setSelectedLegsManeuvers(filters.legs.map((l: number) => String(l)));
      applied = true;
    }
    if (filters.trainingRacing === 'TRAINING' || filters.trainingRacing === 'RACING') {
      setManeuverTrainingRacing(filters.trainingRacing);
      applied = true;
    }
    if (filters.tackEntry === 'PORT' || filters.tackEntry === 'STBD') {
      setManeuverTackEntry(filters.tackEntry);
      applied = true;
    }
    return applied;
  };

  const loadFiltersFromPersistentSettings = async (): Promise<boolean> => {
    const currentUser = user();
    if (!currentUser?.user_id) {
      return false;
    }

    try {
      const className = selectedClassName();
      const projectId = selectedProjectId();
      if (!className || !projectId) {
        return false;
      }

      const settings = await persistentSettingsService.loadSettings(
        currentUser.user_id,
        className,
        projectId
      );

      // Flat display-option key, independent of the maneuverFilters block below.
      if (settings?.liveManeuversTimeWindowMinutes != null) {
        setTimeWindowMinutes(normalizeLiveReportWindowMinutes(settings.liveManeuversTimeWindowMinutes));
      }

      if (!settings?.maneuverFilters) {
        logDebug('LiveManeuvers: No maneuverFilters in persistent settings');
        cachedPersistentManeuverFilters = null;
        return false;
      }

      cachedPersistentManeuverFilters = { ...settings.maneuverFilters };
      applyManeuverFiltersFromSettings(cachedPersistentManeuverFilters);
      logDebug('LiveManeuvers: Loaded maneuver filters from persistent settings', cachedPersistentManeuverFilters);
      return true;
    } catch (error: unknown) {
      logDebug('LiveManeuvers: Error loading filters from persistent settings', error as Error);
      return false;
    }
  };

  const snapshotLiveManeuverFiltersFromPage =(): LiveManeuverSavedFilters => ({
    grades: [...selectedGrades()],
    states: [...selectedStates()],
    races: [...selectedRaces()],
    legs: [...selectedLegs()],
    trainingRacing: maneuverTrainingRacing(),
    tackEntry: maneuverTackEntry(),
  });

  const ensureLiveManeuverFilterOptionBaselines = () => {
    setGradeOptions(LIVE_MANEUVER_GRADE_OPTIONS);
    if (stateOptions().length === 0) {
      setStateOptions([...LIVE_MANEUVER_DEFAULT_STATE_OPTIONS]);
    }
  };

  const applyLiveManeuverTableSortDefault = () => {
    setManeuverTableSort({ key: 'Datetime', direction: 'desc' });
  };

  /** Page-local: which sources get auto-selected (latest-per-source). Persisted in localStorage. */
  const [liveSelectionSourceIds, setLiveSelectionSourceIds] = createSignal<Set<number>>(new Set());

  /**
   * The SHARED source selection (fleetPerformanceSources / filterStore) — drives which maneuvers are
   * fetched/displayed. Not the live map's selection: the map owns its own `liveMapSources` key so
   * that picking boats to watch there does not re-filter this page.
   */
  const displaySourceIds = createMemo(() => sourceIdsFromNames(sharedSelectedSources()));

  const allProjectSourceIds = createMemo(() => {
    const sources = sourcesStore.sources() ?? [];
    return new Set(
      sources
        .map((s: { source_id?: number }) => s.source_id)
        .filter((id: unknown): id is number => typeof id === 'number' && id > 0)
    );
  });

  /** Uppercase source names for selection-scope filtering (matches getManeuverRowSourceName). */
  const liveSelectionSourceNames = createMemo(() => {
    const ids = liveSelectionSourceIds();
    const allIds = allProjectSourceIds();
    if (ids.size === 0 || (allIds.size > 0 && ids.size >= allIds.size && [...allIds].every((id) => ids.has(id)))) {
      return null;
    }
    const names = new Set<string>();
    for (const source of sourcesStore.sources() ?? []) {
      if (source.source_id != null && ids.has(source.source_id) && source.source_name) {
        names.add(String(source.source_name).trim().toUpperCase());
      }
    }
    return names;
  });

  const persistLiveSelectionSourceIds = (ids: Set<number>) => {
    const className = (selectedClassName() || '').trim();
    const projectId = selectedProjectId();
    if (!className || projectId == null) return;
    setStoredLiveManeuverSelectionSources(className, projectId, Array.from(ids));
  };

  const projectValidSourceIds = createMemo(() => {
    const sources = sourcesStore.sources() ?? [];
    return new Set(
      sources
        .map((s: { source_id?: number }) => Number(s.source_id))
        .filter((id: number): id is number => Number.isFinite(id) && id > 0)
    );
  });

  const normalizeSourceIdSet = (ids: Iterable<number | string>, validIds: Set<number>): Set<number> => {
    const next = new Set<number>();
    for (const raw of ids) {
      const id = Number(raw);
      if (Number.isFinite(id) && id > 0 && validIds.has(id)) {
        next.add(id);
      }
    }
    return next;
  };

  const applyLiveSelectionSourceIds = (ids: Set<number>, reason: string): boolean => {
    if (ids.size === 0) return false;
    setLiveSelectionSourceIds(ids);
    persistLiveSelectionSourceIds(ids);
    debug('LiveManeuvers: Initialized selection sources', {
      reason,
      count: ids.size,
      ids: Array.from(ids),
    });
    return true;
  };

  /**
   * "Follow the live edge" — when following (or MAP ALL), poll/load auto-selects the
   * latest maneuver per selection source.
   *
   * Backed by `liveManeuverFollow`, this page's OWN switch — deliberately not the playback clock
   * and not Live Performance's switch. This page accumulates rows rather than sliding a window, so
   * pausing it means "stop moving things under me while I pick some events", which says nothing
   * about whether the boat on the live map (or Performance) should keep advancing. See the block
   * comment above the report follow signals in playbackStore.
   *
   * Default ON; MAP ALL ignores the toggle and always follows.
   */
  const shouldAutoUpdateLiveSelection = () => mapAllOnly() || liveManeuverFollowActive();

  const [showTimeline, setShowTimeline] = createSignal<boolean>(true);
  const handleTimelineChange = (value: boolean) => {
    pauseLiveInteraction('timeline');
    setShowTimeline(value);
    requestAnimationFrame(() => trySettleLiveInteraction());
  };

  /**
   * Display option: how far back the table/charts (and the poll request) reach. Defaults to the
   * last hour so a full race day does not get re-read on every merge poll.
   */
  const [timeWindowMinutes, setTimeWindowMinutes] = createSignal<number>(
    LIVE_REPORT_WINDOW_DEFAULT_MINUTES
  );

  /**
   * Display options apply immediately (no Apply button), so this writes its own flat key rather
   * than going through the filter snapshot — that would commit filter edits the user hasn't applied.
   */
  const persistTimeWindowPreference = async (value: number): Promise<void> => {
    const currentUser = user();
    const className = selectedClassName();
    const projectId = selectedProjectId();
    if (!currentUser?.user_id || !className || !projectId) return;
    try {
      await persistentSettingsService.saveSettings(currentUser.user_id, className, Number(projectId), {
        liveManeuversTimeWindowMinutes: value,
      });
    } catch (err) {
      logDebug('LiveManeuvers: persistTimeWindowPreference failed', err as Error);
    }
  };

  /**
   * Called on Apply, not on click: ManeuverSettings stages the pill and only calls this from its
   * Apply handler (same contract as PerfSettings / LivePerformance). The pause/settle pair still
   * matters because Apply can carry a window change with no filter change, in which case
   * onApplyFilters never runs.
   */
  const handleTimeWindowChange = (value: number) => {
    pauseLiveInteraction('time-window');
    const normalized = normalizeLiveReportWindowMinutes(value);
    setTimeWindowMinutes(normalized);
    void persistTimeWindowPreference(normalized);
    // Refetch in both directions: the store holds whatever the previous window fetched, so widening
    // needs the older rows and narrowing needs the store to stop carrying out-of-window ones (the
    // filterData guard hides them, but they would still feed merges and TWS options).
    //
    // Debounced, not immediate: Apply can call this alongside onApplyFilters, and both routing
    // through scheduleLiveTableFetch collapses them into ONE request that sees the new filters and
    // the new window together. With an immediate fetch here the filter fetch had already started
    // against the OLD window, so a whole-day request was issued and then corrected.
    scheduleLiveTableFetch();
    requestAnimationFrame(() => trySettleLiveInteraction());
  };

  useDashboardShareRestore(
    mapAllOnly()
      ? LIVE_MAP_ALL_PAGE_KEY
      : soloViewName()
        ? `LiveManeuvers_${soloViewName()}`
        : LIVE_MANEUVERS_PAGE_KEY,
    () =>
      buildManeuversShareState({
        view: view(),
        showTimeline: showTimeline(),
        eventType: eventType(),
        phase: phase(),
        color: color(),
        tws: tws(),
        grouped: grouped(),
        groupDisplayMode: groupDisplayMode(),
        selectedRaces: selectedRaces(),
        selectedLegs: selectedLegs(),
        selectedGrades: selectedGrades(),
        selectedStates: selectedStates(),
        selectedSourceIds: Array.from(liveSelectionSourceIds()),
        maneuverTrainingRacing: maneuverTrainingRacing(),
        maneuverTackEntry: maneuverTackEntry(),
        selectedEvents: selectedEvents(),
        hasSelection: hasSelection(),
        maneuverSelection: selection(),
        liveTimeWindowMinutes: timeWindowMinutes(),
      }),
    (obj) =>
      applyManeuversShareState(obj, LIVE_MANEUVERS_PAGE_KEY, {
        setView,
        setShowTimeline,
        setSelectedRaces,
        setSelectedLegs,
        setSelectedGrades,
        setSelectedStates,
        setSelectedSourceIds: (value: unknown) => setLiveSelectionSourceIds(value as Set<number>),
        setLiveTimeWindowMinutes: (value: unknown) =>
          setTimeWindowMinutes(normalizeLiveReportWindowMinutes(value)),
      })
  );

  createEffect(() => {
    if (soloMode()) return;
    const et = (eventType() || '').trim().toUpperCase();
    if (et === 'ALL') {
      setEventType('TACK');
    }
  });

  // Solo submenu switches (MAP, TABLE, …) update props without remounting — sync internal view.
  createEffect(() => {
    const sv = soloViewName();
    if (sv) {
      setView(sv);
    }
  });

  /** Solo views stay mounted after first open so MAP ↔ TABLE does not tear down D3 / tables. */
  const [soloViewsMounted, setSoloViewsMounted] = createSignal<Set<string>>(
    new Set([soloViewName() ?? 'MAP'])
  );
  createEffect(() => {
    if (!soloMode()) return;
    const v = view();
    setSoloViewsMounted((prev) => {
      if (prev.has(v)) return prev;
      const next = new Set(prev);
      next.add(v);
      return next;
    });
  });

  // After first solo data load, mount all solo view panels (hidden) so submenu switches stay instant.
  createEffect(() => {
    if (!soloMode() || !liveMountComplete()) return;
    if (untrack(() => maneuvers().length) === 0) return;
    setSoloViewsMounted((prev) => {
      const next = new Set<string>([...LIVE_MANEUVER_SOLO_VIEWS, ...prev]);
      if (next.size === prev.size && [...next].every((name) => prev.has(name))) {
        return prev;
      }
      return next;
    });
  });
  const soloViewPanelHidden = (panelView: string): boolean =>
    soloMode() && view() !== panelView;
  const showSoloViewPanel = (panelView: string): boolean =>
    soloMode() ? soloViewsMounted().has(panelView) : view() === panelView;

  const fleetManeuverSourceColorScale = createMemo(() => {
    const sources = sourcesStore.sources();
    const isReady = sourcesStore.isReady();
    if (!isReady || sources.length === 0) return null;
    const sourceNames = sources.map((s) => String(s.source_name).toLowerCase());
    const colorsArr = sources.map((s) => sourcesStore.getSourceColor(s.source_name) || '#1f77b4');
    return d3.scaleOrdinal<string, string>().domain(sourceNames).range(colorsArr).unknown('#1f77b4');
  });

  // Memoize view options for live (no VIDEO).
  const viewOptions = createMemo<string[]>(() => {
    const base = grouped() ? ['MAP', 'TABLE', 'BOXES', 'TIME SERIES'] : views();
    return base;
  });

  // Abort controllers for canceling requests
  let tableDataController: AbortController | null = null;
  let timesController: AbortController | null = null;
  let stateOptionsController: AbortController | null = null;

  const applyDiscoveredStateOptions = (discovered: string[]) => {
    if (discovered.length === 0) return;
    setStateOptions(discovered);
    const reconciled = reconcileManeuverStatesWithBaseline(
      selectedStates(),
      discovered,
      false,
      { defaultAllWhenNoSaved: false }
    );
    if (
      reconciled.length !== selectedStates().length ||
      reconciled.some((s, i) => s !== selectedStates()[i])
    ) {
      setSelectedStates(reconciled);
      setSelectedStatesManeuvers(reconciled);
    }
  };

  const refreshManeuverStateOptions = async (requestEventType: string) => {
    const className = selectedClassName();
    const projectId = selectedProjectId();
    const date = (selectedDate() || '').trim();
    if (!className || !projectId || !date) return;

    const sources = sourcesStore.sources() ?? [];
    if (!sourcesStore.isReady() || sources.length === 0) return;

    const selectedSourceIds = displaySourceIds();
    const sourceNames = sources
      .filter((s: { source_id?: number; source_name?: string }) =>
        selectedSourceIds.size === 0 || (s.source_id != null && selectedSourceIds.has(s.source_id))
      )
      .map((s: { source_name?: string }) => s.source_name)
      .filter((name): name is string => typeof name === 'string' && name.trim() !== '');

    if (stateOptionsController) stateOptionsController.abort();
    stateOptionsController = new AbortController();

    const discovered = await fetchFleetDayManeuverStateOptions({
      className,
      projectId,
      date,
      eventType: requestEventType,
      sourceNames,
      liveOnly: true,
      signal: stateOptionsController.signal,
    });
    if (normalizeLiveManeuverEventType(eventType() || DEFAULT_LIVE_MANEUVER_EVENT_TYPE) !== requestEventType) return;
    applyDiscoveredStateOptions(discovered);
  };

  /** After onMount applies project/persistent filters — prevents createEffects from racing ahead and double-fetching. */
  const [liveMountComplete, setLiveMountComplete] = createSignal(false);
  /** True after the first full maneuver fetch attempt finishes (success, empty, or retry). */
  const [liveTableLoadSettled, setLiveTableLoadSettled] = createSignal(false);
  const [liveManeuverPollActive, setLiveManeuverPollActive] = createSignal(false);
  let livePollIndicatorCount = 0;
  const [newLiveEventIds, setNewLiveEventIds] = createSignal<Set<number>>(new Set());
  let liveTableFetchDebounce: ReturnType<typeof setTimeout> | null = null;
  let livePollIntervalId: ReturnType<typeof setInterval> | null = null;
  let liveMergePollPending = false;
  let lastMergePollKey = '';
  let lastMergePollCompletedAt = 0;
  let tableFetchInFlight = false;
  /**
   * When the loop last PROVED it was alive: a merge poll fired, or a table fetch settled. The stall
   * watchdog measures against this, so anything that counts as progress must stamp it.
   */
  let lastLiveProgressAt = Date.now();
  /** When the current table fetch started, so a request that never settles stops counting as progress. */
  let tableFetchStartedAt = 0;
  const markLiveProgress = (): void => { lastLiveProgressAt = Date.now(); };
  let liveInitialLoadDone = false;
  let liveDatasetsEnsuredAt = 0;
  const LIVE_ENSURE_DATASETS_COOLDOWN_MS = 60_000;
  /** Coalesce overlapping full fetches (onMount + effects) instead of aborting in-flight requests. */
  let pendingImmediateFullFetch = false;
  let sourcesWaitRetryTimer: ReturnType<typeof setTimeout> | null = null;
  let activeFullFetchGeneration = 0;
  let aggregateViewLoading = false;
  const mapAllCellLoading = new Map<string, boolean>();

  let livePollIntervalMs = DEFAULT_LIVE_MANEUVER_POLL_MS;
  const LIVE_MANEUVER_FETCH_CACHE_MS = 45_000;

  const getMergePollMinGapMs = (): number =>
    Math.max(1000, livePollIntervalMs - 2_000);

  const restartMergePollTimerIfRunning = () => {
    if (!livePollIntervalId) return;
    clearInterval(livePollIntervalId);
    livePollIntervalId = setInterval(() => {
      void fetchTableData({ merge: true });
    }, livePollIntervalMs);
  };

  const pollCoordinator = createLivePollCoordinator({
    onStartTimer: () => {
      if (livePollIntervalId != null) return;
      markLiveProgress();
      livePollIntervalId = setInterval(() => {
        markLiveProgress();
        void fetchTableData({ merge: true });
      }, livePollIntervalMs);
    },
    onStopTimer: () => {
      if (livePollIntervalId) {
        clearInterval(livePollIntervalId);
        livePollIntervalId = null;
      }
    },
    logDebug: (msg, data) => logDebug(msg, data),
    // logError, not logDebug: a forced release means a pause leaked, and the counts name which one.
    // Without this the watchdog would quietly paper over the next leak instead of reporting it.
    onForceRelease: ({ held, heldTotal }) => {
      logError('LiveManeuvers: live update loop stalled - force-releasing held pauses', {
        held,
        heldTotal,
        aggregateViewLoading,
        tableFetchInFlight,
      } as unknown as Error);
    },
  });

  /**
   * Bookkeeping for the single 'follow' pause on the merge coordinator. Declared next to the
   * coordinator so reset/stall paths can clear it without a temporal-dead-zone dance.
   */
  let followPauseHeld = false;

  const getActiveViewName = (): string => {
    if (mapAllOnly()) return 'MAP ALL';
    const solo = soloViewName();
    if (solo) return solo;
    return view();
  };

  const syncAggregateViewLoading = (loading: boolean) => {
    if (loading === aggregateViewLoading) return;
    aggregateViewLoading = loading;
    if (loading) {
      pollCoordinator.pause('view-load');
    } else {
      pollCoordinator.resume('view-load');
      trySettleLiveInteraction();
    }
  };

  const handlePanelLoadStateChange = (loading: boolean) => {
    syncAggregateViewLoading(loading);
  };

  const handleMapAllCellLoadState = (cellId: string, loading: boolean) => {
    mapAllCellLoading.set(cellId, loading);
    const anyLoading = [...mapAllCellLoading.values()].some(Boolean);
    syncAggregateViewLoading(anyLoading);
  };

  const trySettleLiveInteraction = () => {
    if (tableFetchInFlight || aggregateViewLoading) return;
    let interactionCount = pollCoordinator.getState().pauseCounts.interaction;
    while (interactionCount > 0) {
      pollCoordinator.resume('interaction');
      interactionCount -= 1;
    }
    pollCoordinator.maybeStartTimer();
  };

  const pauseLiveInteraction = (source: string) => {
    pollCoordinator.pause('interaction');
    logDebug('LiveManeuvers: interaction paused', { source });
  };

  const flushPendingMergePoll = () => {
    if (!liveMergePollPending || pollCoordinator.isPaused() || !liveInitialLoadDone) {
      return;
    }
    liveMergePollPending = false;
    void fetchTableData({ merge: true });
  };

  const flushPendingImmediateFullFetch = () => {
    if (!pendingImmediateFullFetch || tableFetchInFlight) {
      return;
    }
    pendingImmediateFullFetch = false;
    queueMicrotask(() => runImmediateLiveTableFetch());
  };

  type FullFetchOutcome = 'success' | 'skipped' | 'aborted' | 'stale';

  const afterNonMergeTableFetchComplete = (outcome: FullFetchOutcome) => {
    pollCoordinator.resume('table-fetch');
    if (outcome === 'skipped') {
      trySettleLiveInteraction();
      return;
    }
    if (outcome === 'aborted' || outcome === 'stale') {
      if (!liveInitialLoadDone) {
        queueMicrotask(() => runImmediateLiveTableFetch());
      }
      trySettleLiveInteraction();
      return;
    }
    liveInitialLoadDone = true;
    pollCoordinator.markInitialLoadDone();
    trySettleLiveInteraction();
  };

  onMount(() => {
    void fetchLiveConfig();
    registerLiveManeuverUpdateGate({
      onSubmenuClick: () => {
        pauseLiveInteraction('submenu');
      },
    });
  });

  createEffect(() => {
    const status = streamingStatusStore.status()();
    syncLiveConfigFromStatus({
      streamingStarted: status.streamingStarted,
      simulationActive: status.simulationActive,
      isLiveProcessingActive: status.isLiveProcessingActive,
    });
  });

  createEffect(() => {
    const ms = liveConfigStore.pollIntervalMs();
    if (ms > 0 && ms !== livePollIntervalMs) {
      livePollIntervalMs = ms;
      restartMergePollTimerIfRunning();
    }
  });

  const resetLiveUpdateLifecycle = () => {
    pollCoordinator.reset();
    // reset() zeroes every pause count, so the held follow pause bookkeeping must agree.
    followPauseHeld = false;
    if (livePollIntervalId) {
      clearInterval(livePollIntervalId);
      livePollIntervalId = null;
    }
    setLiveTableLoadSettled(false);
    liveInitialLoadDone = false;
    liveMergePollPending = false;
    aggregateViewLoading = false;
    mapAllCellLoading.clear();
  };

  const ensureLiveDatasetsForSession = async (): Promise<boolean> => {
    const className = selectedClassName();
    const projectId = selectedProjectId();
    if (!className?.trim() || !projectId || projectId <= 0) {
      return false;
    }

    const status = streamingStatusStore.status()();
    if (!status.isLiveDatasetVisible) {
      return false;
    }

    const now = Date.now();
    if (now - liveDatasetsEnsuredAt < LIVE_ENSURE_DATASETS_COOLDOWN_MS) {
      return true;
    }

    const ok = await ensureLiveDatasetsForProject(projectId, className);
    if (ok) {
      liveDatasetsEnsuredAt = now;
      logInfo('LiveManeuvers: ensured LIVE datasets for today', { projectId, className });
    }
    return ok;
  };

  const beginLivePollIndicator = () => {
    livePollIndicatorCount += 1;
    setLiveManeuverPollActive(true);
  };

  const endLivePollIndicator = () => {
    livePollIndicatorCount = Math.max(0, livePollIndicatorCount - 1);
    setLiveManeuverPollActive(livePollIndicatorCount > 0);
  };

  const liveNewRowHighlightTimers = new globalThis.Map<number, ReturnType<typeof setTimeout>>();

  const liveManeuverRowClass = (row: { event_id?: number }) => {
    const id = row?.event_id;
    return id != null && newLiveEventIds().has(id) ? 'live-maneuver-new' : '';
  };

  const clearLiveNewRowHighlights = () => {
    for (const timer of liveNewRowHighlightTimers.values()) {
      clearTimeout(timer);
    }
    liveNewRowHighlightTimers.clear();
    setNewLiveEventIds(new Set<number>());
  };

  const markNewLiveManeuvers = (eventIds: number[]) => {
    const uniqueIds = [...new Set(eventIds.filter((id) => Number.isFinite(id)))];
    if (uniqueIds.length === 0) return;

    setNewLiveEventIds((prev) => {
      const next = new Set(prev);
      uniqueIds.forEach((id) => next.add(id));
      return next;
    });

    for (const id of uniqueIds) {
      const existingTimer = liveNewRowHighlightTimers.get(id);
      if (existingTimer) clearTimeout(existingTimer);
      const timer = setTimeout(() => {
        liveNewRowHighlightTimers.delete(id);
        setNewLiveEventIds((prev) => {
          if (!prev.has(id)) return prev;
          const next = new Set(prev);
          next.delete(id);
          return next;
        });
      }, LIVE_NEW_ROW_HIGHLIGHT_MS);
      liveNewRowHighlightTimers.set(id, timer);
    }
  };

  const applyPhaseTackLabels = (rows: any[], requestEventType: string) => {
    const evt = (requestEventType || '').toUpperCase();
    const usePortStbd = evt === 'TAKEOFF' || evt === 'BEARAWAY' || evt === 'ROUNDUP';
    rows.forEach((item: any) => {
      if (usePortStbd) {
        const twa = item.twa_entry ?? item.twa_build ?? item.Twa_start ?? 0;
        item.tack = Number(twa) > 0 ? 'STBD' : 'PORT';
      } else if (phase() == 'FULL' || phase() == 'TURN') {
        item.tack = item.twa_entry > 0 ? 'S - P' : 'P - S';
      } else if (phase() == 'INVESTMENT') {
        item.tack = item.twa_entry > 0 ? 'STBD' : 'PORT';
      } else {
        item.tack = item.twa_entry > 0 ? 'PORT' : 'STBD';
      }
    });
  };

  const enrichManeuverDatetimeLocal = (rows: any[]) => {
    rows.forEach((item: any) => {
      const tz = (item.timezone ?? item.Timezone ?? "").trim() || undefined;
      const rawDt = item.Datetime ?? item.datetime;
      if (rawDt && tz) {
        try {
          const formatted = formatDateTime(rawDt, tz);
          if (formatted) item.datetimeLocal = formatted;
        } catch {
          // leave datetimeLocal undefined
        }
      }
    });
  };

  const updateTwsOptionsFromRows = (rows: any[]) => {
    const twsValues: number[] = [];
    rows.forEach((item: any) => {
      const twsBin = item.tws_bin ?? item.tws_avg;
      if (twsBin !== null && twsBin !== undefined && !isNaN(Number(twsBin))) {
        twsValues.push(Number(twsBin));
      }
    });

    const tws_bins: string[] = ['ALL'];
    if (twsValues.length > 0) {
      const minTws = Math.min(...twsValues);
      const maxTws = Math.max(...twsValues);
      const startBin = Math.floor(minTws / 5) * 5;
      const endBin = Math.ceil(maxTws / 5) * 5 + 5;
      for (let bin = startBin; bin <= endBin; bin += 5) {
        tws_bins.push(String(bin));
      }
    }
    setTwsOptions(tws_bins);

    const baseline = stateOptions();
    if (baseline.length === 0) return;
    const reconciled = reconcileManeuverStateSelection(selectedStates(), baseline, { defaultAll: false });
    if (
      reconciled.length !== selectedStates().length ||
      reconciled.some((s, i) => s !== selectedStates()[i])
    ) {
      setSelectedStates(reconciled);
      setSelectedStatesManeuvers(reconciled);
    }
  };

  const mergeManeuverRowsByEventId = (existingRows: any[], incomingRows: any[]) => {
    const byId = new globalThis.Map<number, any>();
    for (const row of existingRows) {
      const id = Number(row?.event_id);
      if (Number.isFinite(id)) byId.set(id, row);
    }
    const newEventIds: number[] = [];
    for (const row of incomingRows) {
      const id = Number(row?.event_id);
      if (!Number.isFinite(id)) continue;
      if (!byId.has(id)) newEventIds.push(id);
      const prev = byId.get(id);
      byId.set(id, prev ? { ...prev, ...row } : row);
    }
    return { merged: Array.from(byId.values()), newEventIds };
  };

  /**
   * Live auto-follow: highlight the latest maneuver per source. Writes the dedicated live highlight
   * layer (NOT the selection store) so the selection banner and cut/clear/grade stay manual-only.
   * Charts render `highlightedEventIds()` (manual ∪ live); setTriggerSelection just forces the repaint.
   */
  const syncLiveSelectionToLatestPerSource = (
    rows: Record<string, unknown>[],
    opts?: { replaceAll?: boolean; sourcesToRefresh?: string[]; force?: boolean }
  ) => {
    if (!opts?.force && !shouldAutoUpdateLiveSelection()) return;

    const latestBySource = latestEventIdsBySource(rows);
    if (latestBySource.size === 0) {
      if (opts?.replaceAll) {
        setLiveHighlightEvents([]);
        setTriggerSelection(true);
      }
      return;
    }

    const selectionNames = liveSelectionSourceNames();
    const sourceInSelectionScope = (sourceName: string): boolean =>
      selectionNames === null || selectionNames.has(sourceName);

    const rowByEventId = new Map<number, Record<string, unknown>>();
    for (const row of rows) {
      const id = Number(row?.event_id);
      if (Number.isFinite(id)) rowByEventId.set(id, row);
    }

    const prev = liveHighlightEvents();
    let nextIds: number[];
    if (opts?.replaceAll) {
      const next: number[] = [];
      for (const [src, eventId] of latestBySource) {
        if (sourceInSelectionScope(src)) next.push(eventId);
      }
      nextIds = next.sort((a, b) => a - b);
    } else {
      let refreshSources = new Set(
        (opts?.sourcesToRefresh ?? []).map((s) => s.trim().toUpperCase()).filter(Boolean)
      );
      if (selectionNames !== null) {
        refreshSources = new Set([...refreshSources].filter((s) => selectionNames.has(s)));
      }
      if (refreshSources.size === 0) return;

      const next = new Set(prev);
      for (const id of prev) {
        const row = rowByEventId.get(id);
        const src = row ? getManeuverRowSourceName(row) : '';
        if (src && refreshSources.has(src)) next.delete(id);
      }
      for (const [src, eventId] of latestBySource) {
        if (refreshSources.has(src)) next.add(eventId);
      }
      nextIds = [...next].sort((a, b) => a - b);
    }
    setLiveHighlightEvents(nextIds);
    setTriggerSelection(true);
  };

  /**
   * Hold at most ONE 'follow' pause on the merge coordinator. The coordinator is ref-counted, so a
   * plain pause/resume pair per toggle drifts the moment an edge is missed — and the edge that
   * matters most is mount-already-paused: a deferred effect would capture the already-false value
   * and skip, leaving a paused page with its merge timer running. Undeferred, like Alinghi.
   * MAP ALL ignores the toggle and always follows.
   */
  const syncFollowPause = (follow: boolean): void => {
    if (mapAllOnly()) {
      if (followPauseHeld) {
        followPauseHeld = false;
        pollCoordinator.resume('follow');
      }
      return;
    }
    if (!follow && !followPauseHeld) {
      followPauseHeld = true;
      pollCoordinator.pause('follow');
    } else if (follow && followPauseHeld) {
      followPauseHeld = false;
      pollCoordinator.resume('follow');
    }
  };

  // Follow gate: suspend/resume merges. Undeferred on purpose so a page that mounts already paused
  // still holds the coordinator 'follow' pause (see syncFollowPause).
  createEffect(() => {
    if (!liveMode()) return;
    syncFollowPause(liveManeuverFollowActive());
  });

  // Follow lifecycle (visible side): refill or drop the live highlight. Deferred so the initial
  // selection is handled by the normal load path; this only fires on subsequent toggles.
  createEffect(
    on(
      liveManeuverFollowActive,
      (follow) => {
        if (mapAllOnly()) return;
        if (follow) {
          syncLiveSelectionToLatestPerSource(
            untrack(() => maneuvers()) as Record<string, unknown>[],
            { replaceAll: true, force: true }
          );
        } else {
          // Paused: drop only the live highlight layer; a manual selection in the store must survive.
          setLiveHighlightEvents([]);
          setTriggerSelection(true);
        }
      },
      { defer: true }
    )
  );

  /**
   * Pressing PLAY drops the manual selection the pause was taken to make.
   *
   * The select-to-pause effect below is the other half of this: picking maneuvers by hand pauses
   * follow, so resuming has to undo it, or the page follows the edge with the old picks still
   * highlighted and the timeseries/table still filtered to them. Paused means "hold still while I
   * look at THESE"; play means "show me the latest again".
   *
   * Keyed on the RAW `liveManeuverFollow` rather than `liveManeuverFollowActive`, deliberately: only a
   * user gesture writes this signal (see the block comment in playbackStore), whereas `active` also
   * flips with `liveMode` - which this page itself re-asserts and a sibling live map can clear.
   * Clearing on that would be the "selection wiped as if in live mode" bug again. `defer: true` plus
   * the `wasFollowing` check narrows it to the OFF -> ON edge.
   *
   * Domain-scoped to `'maneuver'` so an aggregate selection held by Live Performance in the other
   * half of a split view survives. The live highlight layer is untouched - the resume effect above
   * has just refilled it with the latest per source, which is what should be on screen now.
   */
  createEffect(
    on(
      liveManeuverFollow,
      (following, wasFollowing) => {
        if (!following || wasFollowing) { return; }
        if (!liveMode() || mapAllOnly()) { return; }
        if (selectedEvents().length === 0) { return; }
        debug('LiveManeuvers: follow resumed - clearing the manual selection');
        clearSelection({ preserveFilters: true, domain: 'maneuver' });
      },
      { defer: true }
    )
  );

  const sourcesForEventIds = (rows: Record<string, unknown>[], eventIds: number[]): string[] => {
    const byId = new Map<number, Record<string, unknown>>();
    for (const row of rows) {
      const id = Number(row?.event_id);
      if (Number.isFinite(id)) byId.set(id, row);
    }
    const sources: string[] = [];
    for (const id of eventIds) {
      const row = byId.get(id);
      if (!row) continue;
      const src = getManeuverRowSourceName(row);
      if (src) sources.push(src);
    }
    return sources;
  };

  const applyFetchedManeuverData = (
    allData: any[],
    requestEventType: string,
    mode: 'replace' | 'merge',
    multiTypeFetch = false
  ) => {
    enrichManeuverDatetimeLocal(allData);
    if (multiTypeFetch) {
      for (const type of LIVE_ALL_GRID_MANEUVER_TYPES) {
        const subset = allData.filter((row) => getManeuverRowEventType(row) === type);
        applyPhaseTackLabels(subset, type);
      }
    } else {
      applyPhaseTackLabels(allData, requestEventType);
    }

    if (mode === 'merge') {
      const { merged, newEventIds } = mergeManeuverRowsByEventId(untrack(() => maneuvers()), allData);
      if (merged.length === 0 && allData.length === 0) {
        return;
      }
      // Poll merge: skip store/table/map refresh when nothing new — avoids re-triggering row fade and map redraws.
      if (newEventIds.length === 0) {
        return;
      }
      updateTwsOptionsFromRows(merged);
      setManeuvers(merged as any);
      markNewLiveManeuvers(newEventIds);
      const sourcesToRefresh = sourcesForEventIds(merged as Record<string, unknown>[], newEventIds);
      // Poll auto-advance to the latest maneuver only while following the live edge; never when paused.
      if (shouldAutoUpdateLiveSelection()) {
        syncLiveSelectionToLatestPerSource(merged as Record<string, unknown>[], { sourcesToRefresh });
      }
      filterData(merged);
      return;
    }

    clearLiveNewRowHighlights();
    if (allData.length > 0) {
      updateTwsOptionsFromRows(allData);
      setManeuvers(allData);
      filterData(allData, { syncLatestSelection: true });
      return;
    }

    setManeuvers([]);
    setTableData([]);
    setFiltered([]);
    setTwsOptions(['ALL']);
  };

  let liveSourcesWaitLogged = false;

  const fetchTableData = async (options?: { merge?: boolean }) => {
    const merge = options?.merge === true;
    // Skip live poll merges when paused (not following the live edge). pollCoordinator.pause('follow')
    // is applied by a deferred effect that only fires on toggle, so guard on the follow state directly
    // — otherwise a page that mounts already-paused keeps merging new data and re-rendering the map.
    if (merge && (pollCoordinator.isPaused() || !shouldAutoUpdateLiveSelection())) {
      liveMergePollPending = true;
      return;
    }
    if (merge && tableFetchInFlight) {
      liveMergePollPending = true;
      return;
    }

    if (!merge && tableFetchInFlight) {
      pendingImmediateFullFetch = true;
      logDebug('LiveManeuvers: full fetch already in flight — will retry when current fetch finishes');
      return;
    }

    const className = (selectedClassName() || '').trim();
    const projectId = Number(selectedProjectId());
    if (!merge && (!className || !Number.isFinite(projectId) || projectId <= 0)) {
      logInfo('LiveManeuvers: cannot fetch maneuvers — missing project context', {
        className,
        projectId,
      });
      setLiveTableLoadSettled(true);
      return;
    }

    const thisFetchController = new AbortController();
    const fetchSignal = thisFetchController.signal;
    const fetchGeneration = !merge ? ++activeFullFetchGeneration : 0;
    if (!merge) {
      tableDataController = thisFetchController;
    }

    tableFetchInFlight = true;
    tableFetchStartedAt = Date.now();
    if (!merge) {
      pollCoordinator.pause('table-fetch');
    }
    let fullFetchOutcome: FullFetchOutcome | 'none' = 'none';
    const multiTypeFetch = mapAllOnly();
    const requestEventType = multiTypeFetch
      ? 'MAP_ALL'
      : (eventType() || DEFAULT_LIVE_MANEUVER_EVENT_TYPE).trim() || DEFAULT_LIVE_MANEUVER_EVENT_TYPE;
    const requestModeKey = multiTypeFetch
      ? 'MAP_ALL'
      : normalizeLiveManeuverEventType(requestEventType);
    const eventTypesToFetch = multiTypeFetch
      ? [...LIVE_ALL_GRID_MANEUVER_TYPES]
      : [requestEventType];
    let showPollIndicator = false;

    const selectedSourceIds = displaySourceIds();
    const sourcesForKey = sourcesStore.sources() ?? [];
    const pollKey = JSON.stringify({
      mode: requestModeKey,
      date: getLiveManeuverQueryDateYmd(),
      sourceIds: [...selectedSourceIds].sort((a, b) => a - b),
      grades: [...selectedGrades()].sort(),
      states: [...selectedStates()].sort(),
      tr: maneuverTrainingRacing(),
      nsrc: sourcesForKey.length,
      // Part of the key so switching Last hour <-> All is never served from the dedupe cache.
      win: timeWindowMinutes(),
    });
    if (
      merge &&
      pollKey === lastMergePollKey &&
      Date.now() - lastMergePollCompletedAt < getMergePollMinGapMs()
    ) {
      logDebug('LiveManeuvers: skipping merge poll (too soon after last poll)', { mode: requestModeKey });
      tableFetchInFlight = false;
      markLiveProgress();
      return;
    }

    if (
      !merge &&
      liveManeuverFetchCache &&
      liveManeuverFetchCache.key === pollKey &&
      Date.now() - liveManeuverFetchCacheAt < LIVE_MANEUVER_FETCH_CACHE_MS
    ) {
      logDebug('LiveManeuvers: using cached maneuver fetch', { mode: requestModeKey });
      applyFetchedManeuverData(
        liveManeuverFetchCache.rows as Record<string, unknown>[],
        requestModeKey,
        'replace',
        multiTypeFetch
      );
      tableFetchInFlight = false;
      markLiveProgress();
      if (tableDataController === thisFetchController) {
        tableDataController = null;
      }
      fullFetchOutcome = 'success';
      setLiveTableLoadSettled(true);
      afterNonMergeTableFetchComplete('success');
      return;
    }

    try {
      // Poll merges reuse existing maneuver rows — skip streaming refresh (13+ source calls).
      if (!merge) {
        const statusAge = Date.now() - streamingStatusStore.status()().lastUpdated;
        if (statusAge > STREAMING_STATUS_MAX_AGE_MS) {
          await streamingStatusStore.refresh().catch(() => {});
        }
        if (fetchSignal.aborted) {
          fullFetchOutcome = 'aborted';
          return;
        }
        await ensureLiveDatasetsForSession();
        if (fetchSignal.aborted) {
          fullFetchOutcome = 'aborted';
          return;
        }
      }

      const date = getLiveManeuverQueryDateYmd();
      const persistedDate = (selectedDate() || '').trim();
      if (!persistedDate || persistedDate === '0') {
        setSelectedDate(date);
        logDebug('LiveManeuvers: set selectedDate for LIVE maneuver query', date);
      }

      const sourcesReady = sourcesStore.isReady();
      const sources = sourcesStore.sources();
      if (!sourcesReady || !sources || sources.length === 0) {
        if (!liveSourcesWaitLogged) {
          liveSourcesWaitLogged = true;
          logInfo('LiveManeuvers: waiting for project sources before maneuver fetch', {
            sourcesReady,
            sourcesCount: sources?.length ?? 0,
          });
        }
        logDebug('LiveManeuvers: fetchTableData skipped — sources not ready', {
          merge,
          eventType: requestEventType,
          sourcesReady,
          sourcesCount: sources?.length ?? 0,
        });
        if (!merge) {
          setManeuvers([]);
          setTableData([]);
          setFiltered([]);
          setTwsOptions(['ALL']);
        }
        fullFetchOutcome = 'skipped';
        if (!sourcesWaitRetryTimer) {
          sourcesWaitRetryTimer = setTimeout(() => {
            sourcesWaitRetryTimer = null;
            runImmediateLiveTableFetch();
          }, 300);
        }
        return;
      }
      liveSourcesWaitLogged = false;
      if (sourcesWaitRetryTimer) {
        clearTimeout(sourcesWaitRetryTimer);
        sourcesWaitRetryTimer = null;
      }

      const allData: any[] = [];
      const filters: Record<string, number[] | string[]> = {};
      const grades = selectedGrades();
      if (grades.length > 0) {
        filters.GRADE = grades.map(g => Number(g)).filter(n => !isNaN(n));
      }
      const trainingRacingVal = maneuverTrainingRacing();
      if (trainingRacingVal === 'TRAINING' || trainingRacingVal === 'RACING') {
        filters.TRAINING_RACING = [trainingRacingVal];
      }

      let sourcesToFetch = selectedSourceIds.size > 0
        ? sources.filter((s: any) => selectedSourceIds.has(s.source_id))
        : sources;
      if (sourcesToFetch.length === 0 && sources.length > 0) {
        logDebug('LiveManeuvers: displaySourceIds matched no project sources — using all sources');
        sourcesToFetch = sources;
      }

      logInfo('LiveManeuvers: fetching maneuvers', {
        merge,
        eventType: requestModeKey,
        eventTypesToFetch,
        date,
        live_only: true,
        sourceCount: sourcesToFetch.length,
        grades: selectedGrades(),
      });

      logDebug('LiveManeuvers: fetchTableData', {
        merge,
        eventType: requestModeKey,
        eventTypesToFetch,
        date,
        sourceCount: sourcesToFetch.length,
        grades: selectedGrades(),
        states: selectedStates(),
      });

      // One request per event type covering every selected source. /maneuvers takes source_names as
      // an array and returns d.source_name on each row, so the old per-source fan-out was issuing
      // sources x eventTypes whole-day queries per poll tick (52 in MAP-ALL with 13 boats).
      const sourceNamesToFetch = sourcesToFetch.map((source: any) => source.source_name);
      const canonicalSourceNames = new Map<string, string>(
        sourceNamesToFetch.map((name: string) => [String(name).trim().toLowerCase(), name])
      );
      // Computed once per fetch so every event type in a MAP-ALL pass shares one lower bound.
      const windowStartIso = liveReportWindowStartIso(timeWindowMinutes());
      const fetchTasks = eventTypesToFetch.map((typeForFetch: string) => {
        const channelsToRequest = buildManeuversChannelsRequest(typeForFetch, MANEUVERS_CHANNELS, {
          takeoffPrefix: ['twa_entry'],
        });
        let url = `${apiEndpoints.app.data}/maneuvers?class_name=${encodeURIComponent(selectedClassName())}&project_id=${encodeURIComponent(selectedProjectId())}&date=${encodeURIComponent(date)}&event_type=${encodeURIComponent(typeForFetch)}&channels=${encodeURIComponent(JSON.stringify(channelsToRequest))}&live_only=true`;
        if (Object.keys(filters).length > 0) {
          url += `&filters=${encodeURIComponent(JSON.stringify(filters))}`;
        }
        url += `&source_names=${encodeURIComponent(JSON.stringify(sourceNamesToFetch))}`;
        // Omitted entirely for the "All" window, so that URL stays identical to the pre-window one.
        if (windowStartIso) {
          url += `&start_time=${encodeURIComponent(windowStartIso)}`;
        }

        return async (): Promise<any[]> => {
          try {
            const result = await getData(url, fetchSignal);

            if (result.success && result.data && Array.isArray(result.data)) {
              return result.data.map((item: any) => ({
                ...item,
                // Normalize to the sources-store casing so per-team colours, selection and map
                // attribution behave exactly as they did when the caller stamped the name.
                source_name: canonicalSourceNames.get(String(item.source_name).trim().toLowerCase()) ?? item.source_name,
                live_maneuver_type: (typeForFetch || '').trim().toUpperCase(),
              }));
            }
            return [];
          } catch (error: unknown) {
            if (error instanceof Error && error.name === 'AbortError') {
              return [];
            }
            logError(`LiveManeuvers: error fetching maneuver data (${typeForFetch}):`, error as any);
            return [];
          }
        };
      });

      const results = await runWithConcurrency(fetchTasks, LIVE_MANEUVER_FETCH_CONCURRENCY);

      if (!multiTypeFetch && normalizeLiveManeuverEventType(eventType() || DEFAULT_LIVE_MANEUVER_EVENT_TYPE) !== requestModeKey) {
        logDebug('LiveManeuvers: discarding stale full fetch', {
          requestModeKey,
          current: eventType(),
        });
        fullFetchOutcome = 'stale';
        scheduleLiveTableFetch(false);
        return;
      }

      if (!merge && fetchGeneration !== activeFullFetchGeneration) {
        logDebug('LiveManeuvers: discarding superseded full fetch', { fetchGeneration, active: activeFullFetchGeneration });
        fullFetchOutcome = 'stale';
        return;
      }

      results.forEach((sourceData: any[]) => {
        allData.push(...sourceData);
      });

      if (requestModeKey === 'TAKEOFF' || !merge) {
        logDebug('LiveManeuvers: fetchTableData results', {
          eventType: requestModeKey,
          merge,
          totalRows: results.reduce((sum, arr) => sum + (arr?.length ?? 0), 0),
        });
      }

      const totalRows = results.reduce((sum, arr) => sum + (arr?.length ?? 0), 0);
      if (merge) {
        const existingIds = new Set(
          untrack(() => maneuvers())
            .map((row) => Number(row?.event_id))
            .filter((id) => Number.isFinite(id))
        );
        const newRowCount = allData.filter((row) => {
          const id = Number(row?.event_id);
          return Number.isFinite(id) && !existingIds.has(id);
        }).length;
        if (newRowCount > 0) {
          showPollIndicator = true;
          beginLivePollIndicator();
        }
        logInfo('LiveManeuvers: poll complete', {
          eventType: requestModeKey,
          totalRows,
          newRows: newRowCount,
        });
      } else {
        logInfo('LiveManeuvers: fetch complete', { eventType: requestModeKey, totalRows });
      }

      if (!merge && !multiTypeFetch) {
        await refreshManeuverStateOptions(requestModeKey);
      }

      applyFetchedManeuverData(allData, requestModeKey, merge ? 'merge' : 'replace', multiTypeFetch);
      if (!merge) {
        fullFetchOutcome = 'success';
      }
      if (!merge && allData.length >= 0) {
        liveManeuverFetchCache = { key: pollKey, rows: allData };
        liveManeuverFetchCacheAt = Date.now();
      }
      if (merge) {
        lastMergePollKey = pollKey;
        lastMergePollCompletedAt = Date.now();
      }
    } catch (error: unknown) {
      if (error instanceof Error && error.name === 'AbortError') {
        if (!merge) {
          fullFetchOutcome = 'aborted';
        }
      } else if (multiTypeFetch || normalizeLiveManeuverEventType(eventType() || DEFAULT_LIVE_MANEUVER_EVENT_TYPE) === requestModeKey) {
        logError('LiveManeuvers: error fetching table data:', error as any);
        setManeuvers([]);
        setTableData([]);
        setFiltered([]);
        setTwsOptions(['ALL']);
      }
    } finally {
      tableFetchInFlight = false;
      markLiveProgress();
      if (tableDataController === thisFetchController) {
        tableDataController = null;
      }
      if (showPollIndicator) {
        endLivePollIndicator();
      }
      if (!merge) {
        setLiveTableLoadSettled(true);
        if (fullFetchOutcome !== 'none' && fetchGeneration === activeFullFetchGeneration) {
          afterNonMergeTableFetchComplete(fullFetchOutcome);
        } else if (fullFetchOutcome === 'none') {
          pollCoordinator.resume('table-fetch');
        }
      } else if (liveMergePollPending && !pollCoordinator.isPaused()) {
        flushPendingMergePoll();
      }
      flushPendingImmediateFullFetch();
    }
  };

  const scheduleLiveTableFetch = (merge = false) => {
    if (merge) {
      void fetchTableData({ merge: true });
      return;
    }
    if (liveMountComplete() && liveInitialLoadDone) {
      pauseLiveInteraction('table-refetch');
    }
    if (liveTableFetchDebounce) clearTimeout(liveTableFetchDebounce);
    liveTableFetchDebounce = setTimeout(() => {
      liveTableFetchDebounce = null;
      void fetchTableData({ merge: false });
    }, 100);
  };

  /** First load / source-ready refresh — no debounce so solo windows (MAP ALL, etc.) populate immediately. */
  const runImmediateLiveTableFetch = () => {
    if (liveTableFetchDebounce) {
      clearTimeout(liveTableFetchDebounce);
      liveTableFetchDebounce = null;
    }
    if (tableFetchInFlight) {
      pendingImmediateFullFetch = true;
      return;
    }
    void fetchTableData({ merge: false });
  };

  const handleEventType = (val: string): void => {
    pauseLiveInteraction('event-type');
    const prev = normalizeLiveManeuverEventType(eventType());
    const next = normalizeLiveManeuverEventType(val);
    if (next === prev) return;
    setEventType(next);
    clearManeuverSelectionOnEventTypeChange('LiveManeuvers');
    ensureLiveManeuverFilterOptionBaselines();
    void refreshManeuverStateOptions(next);
    runImmediateLiveTableFetch();
  };

  const handlePhase = (val: string): void => {
    pauseLiveInteraction('phase');
    setPhase(val)
    setTriggerUpdate(true);
  };

  const handleView = async (val: string): Promise<void> => {
    pauseLiveInteraction('view');
    const normalized = (val === 'BOXES') ? 'SCATTER' : val;
    if (normalized === 'MAP' || normalized === 'TABLE' || normalized === 'SCATTER' || normalized === 'TIME SERIES') {
      setView(normalized);
      const { project_id, dataset_id } = await getCurrentProjectDatasetIds();
      await logActivity(project_id, dataset_id, 'FleetManeuvers.tsx', 'Fleet Maneuvers Report', `View changed to ${normalized}`);
      filterData();
    }
    setTriggerUpdate(true);
  };

  // Force SCATTER/BOXES content to remount and redraw when grouped toggles
  createEffect(() => {
    const g = grouped();
    if (view() === 'SCATTER') {
      setScatterKey((k: number) => k + 1);
    }
  });

  const handleColor = async (val: string): Promise<void> => {
    pauseLiveInteraction('color');
    setColor(val)
    const { project_id, dataset_id } = await getCurrentProjectDatasetIds();
    await logActivity(project_id, dataset_id, 'FleetManeuvers.tsx', 'Fleet Maneuvers Report', `Color changed to ${val}`);
    setTriggerUpdate(true);
    requestAnimationFrame(() => trySettleLiveInteraction());
  };

  const filterData = (dataOverride?: any[], opts?: { syncLatestSelection?: boolean }): void => {
    // Use provided data or read from store - this avoids race conditions
    const maneuversData = dataOverride ?? maneuvers();
    if (!maneuversData || !Array.isArray(maneuversData) || maneuversData.length === 0) {
      setFiltered([]);
      setTableData([]);
      return;
    }

    let filteredData_tws: any[] = []

    if (tws() == 'ALL') {
      filteredData_tws = maneuversData;
    } else {
      // Filter data where TWS value is within ±2.5 of the selected bin (intervals of 5)
      const selectedTws = Number(tws());
      if (!isNaN(selectedTws)) {
        filteredData_tws = maneuversData.filter((item: any) => {
          const itemTws = item.tws_bin ?? item.tws_avg;
          if (itemTws === null || itemTws === undefined || isNaN(Number(itemTws))) {
            return false;
          }
          const itemTwsNum = Number(itemTws);
          // Filter within ±2.5 of the selected bin value
          // Bin 10 includes values from 7.5 to 12.5 (exclusive on upper bound to avoid overlap)
          const minTws = selectedTws - 2.5;
          const maxTws = selectedTws + 2.5;
          return itemTwsNum >= minTws && itemTwsNum < maxTws;
        });
      } else {
        filteredData_tws = [];
      }
    }

    // Apply grade filter using selectedGrades array - use "greater than" logic
    // Use lowercase field names as primary with fallbacks for backward compatibility
    let filteredData: any[] = filteredData_tws;
    const grades = selectedGrades();
    if (grades.length > 0) {
      // For radio button behavior, only the first selected grade is used
      // Filter for grades greater than the selected grade
      const minGrade = Math.min(...grades.map(g => Number(g)).filter(g => !isNaN(g)));
      filteredData = filteredData_tws.filter((item: any) => {
        const itemGrade = item.grade ?? item.Grade ?? item.GRADE;
        if (itemGrade == null || itemGrade === undefined) return false;
        const numGrade = Number(itemGrade);
        if (isNaN(numGrade)) return false;
        return numGrade > minGrade;
      });
    }

    // Apply state filter using selectedStates array
    // Use lowercase field names as primary with fallbacks for backward compatibility
    const states = selectedStates();
    if (states.length > 0) {
      filteredData = filteredData.filter((item: any) => {
        const itemState = item.state ?? item.State ?? item.STATE;
        if (itemState == null || itemState === undefined) return false;
        const stateStr = String(itemState).trim();
        return states.some(selectedState => String(selectedState).trim().toLowerCase() === stateStr.toLowerCase());
      });
    }

    const races = selectedRaces();
    if (races.length > 0) {
      filteredData = filteredData.filter((item) => passesManeuverRaceFilter(item, races));
    }

    // Apply leg filter using selectedLegs array
    // Use lowercase field names as primary with fallbacks for backward compatibility
    const legs = selectedLegs();
    if (legs.length > 0) {
      filteredData = filteredData.filter((item: any) => {
        const legValue = item.leg_number ?? item.Leg_number ?? item.LEG;
        if (legValue == null || legValue === undefined) return false;
        return legs.includes(Number(legValue));
      });
    }

    const trainingRacing = maneuverTrainingRacing();
    if (trainingRacing) {
      filteredData = filteredData.filter((item) => passesManeuverTrainingRacingFilter(item, trainingRacing));
    }

    // Time window. The request already carries start_time, so this is a belt-and-braces guard that
    // also trims rows already in the store from before the window was narrowed (or from a merge
    // whose start_time was computed a little earlier than this render).
    const windowStartMs = liveReportWindowStartMs(timeWindowMinutes());
    if (windowStartMs != null) {
      filteredData = filteredData.filter((item: any) => {
        const raw = item?.Datetime ?? item?.datetime;
        if (!raw) return true; // keep rows we cannot place in time rather than silently dropping them
        const ts = new Date(raw).getTime();
        return !Number.isFinite(ts) || ts >= windowStartMs;
      });
    }

    filteredData = applyManeuverEntrySide(filteredData, maneuverTackEntry()) as typeof filteredData;

    // If we have cut events, only show the cut maneuvers
    if (isCut() && cutEvents().length > 0) {
      const currentCutEvents = cutEvents();
      const cutIds = currentCutEvents
        .map((item) => {
          if (typeof item === 'number') {
            return Number(item);
          }
          if (item && typeof item === 'object' && 'event_id' in item) {
            const ev = (item as { event_id: unknown }).event_id;
            return typeof ev === 'number' ? ev : Number(ev);
          }
          return NaN;
        })
        .filter((id): id is number => Number.isFinite(id));

      if (cutIds.length > 0) {
        const cutIdSet = new Set(cutIds);
        filteredData = filteredData.filter((maneuver: any) => {
          const mid = Number(maneuver.event_id);
          return Number.isFinite(mid) && cutIdSet.has(mid);
        });
      } else {
        filteredData = [];
      }
    }

    const sortedRows = sortManeuverRows(filteredData, maneuverTableSort(), eventType());

    const eventIds = sortedRows.map((item: any) => item.event_id);

    setFiltered(eventIds)
    setTableData(sortedRows)

    // Live: latest visible maneuver per selected source on load/refetch; poll auto-advance still uses Auto Update.
    // Only when following the live edge — in paused mode we must not re-select the latest data, otherwise a
    // refetch triggered by a hotkey (grade/clear) or filter change would clobber the user's paused selection.
    if ((opts?.syncLatestSelection || !hasSelection()) && shouldAutoUpdateLiveSelection()) {
      syncLiveSelectionToLatestPerSource(sortedRows as Record<string, unknown>[], {
        replaceAll: true,
        force: opts?.syncLatestSelection === true,
      });
    }

    // FleetManeuvers: always bump map/table after filter pass (sort-only changes still refresh)
    setTriggerUpdate(true);

    const active = getActiveViewName();
    if (active === 'TABLE' || active === 'SCATTER') {
      requestAnimationFrame(() => trySettleLiveInteraction());
    }
  }

  useOpenGradeAllForMapClick({
    ready: liveMountComplete,
    grades: selectedGrades,
    setSelectedGrades,
    reload: () => {
      void fetchTableData();
    },
  });

  const hasManeuvers = createMemo(() => {
    const maneuversData = maneuvers();
    return maneuversData && Array.isArray(maneuversData) && maneuversData.length > 0;
  });

  const hasFilteredManeuvers = createMemo(() => {
    const filteredIds = filtered();
    return filteredIds && Array.isArray(filteredIds) && filteredIds.length > 0;
  });

  const maneuverTimelinePoints = createMemo(() => {
    const rows = tabledata();
    if (!rows?.length) return [] as Record<string, unknown>[];
    return mapManeuverRowsToScatterTimeseriesPoints(rows as Record<string, unknown>[]);
  });

  const maneuverTimelineGroups = createMemo(() => {
    const rows = tabledata();
    return maneuverTimelineLegendGroups(rows as Record<string, unknown>[], color());
  });

  // Expensive pass: grouping + colours. Re-runs on data or colour-mode change only.
  const maneuverColorLegendBase = createMemo(() => {
    const rows = tabledata() as Record<string, unknown>[];
    // Touch the sources store so SOURCE colours repaint once the fleet colours load.
    if (String(color() || '').toUpperCase() === 'SOURCE') {
      sourcesStore.sources();
      sourcesStore.isReady();
    }
    return buildManeuverColorLegendItems(rows, color(), {
      eventType: eventType(),
    });
  });

  // Cheap pass: pill rings track the same selection the views highlight.
  const maneuverColorLegendItems = createMemo(() =>
    applyManeuverLegendSelection(maneuverColorLegendBase(), color(), {
      grouped: grouped(),
      selectedGroupKeys: grouped() ? selectedGroupKeys() : undefined,
      selectedEventIds: grouped() ? undefined : selectedEvents(),
    })
  );

  // The legend wraps, so its height changes with the colour mode — measured into the MAP/TABLE
  // height math rather than assumed.
  const [legendRowEl, setLegendRowEl] = createSignal<HTMLDivElement | undefined>(undefined);
  createEffect(() => {
    const el = legendRowEl();
    if (!el) return;
    const ro = new ResizeObserver(() => { updateContainerHeights(); });
    ro.observe(el);
    onCleanup(() => ro.disconnect());
  });

  // When table rows exist but the scatter mapper yields nothing, log one diagnostic row (time/id keys).
  createEffect(
    on(
      () => [tabledata().length, maneuverTimelinePoints().length] as const,
      ([tableLen, ptLen]) => {
        if (tableLen === 0 || ptLen > 0) return;
        const rows = tabledata();
        const sample = rows[0] as Record<string, unknown> | undefined;
        logDebug('FleetManeuvers: table rows present but zero timeline scatter points — check datetime/event_id on row shape', {
          tableLen,
          sampleKeys: sample ? Object.keys(sample).slice(0, 42) : [],
          event_id: sample?.event_id ?? sample?.Event_id,
          Datetime: sample?.Datetime,
          datetime: sample?.datetime,
          start_time: sample?.start_time,
        });
      }
    )
  );

  /** Reserve controls + map/table height and show strip whenever timeline is on and the table has rows (same as FleetManeuversHistory). */
  const showSelectionTimelineStrip = createMemo(() => showTimeline() && hasFilteredManeuvers());

  const handleTws = async (val: string): Promise<void> => {
    pauseLiveInteraction('tws');
    setTws(val)
    const { project_id, dataset_id } = await getCurrentProjectDatasetIds();
    await logActivity(project_id, dataset_id, 'FleetManeuvers.tsx', 'Fleet Maneuvers Report', `TWS changed to ${val}`);
    filterData()
  };


  const handleLegendClick = (legendItem: string) => {
    pauseLiveInteraction('legend');
    // In grouped mode, legend toggles group selection (same key format and toggle as grouped DataTable)
    if (grouped()) {
      const key = legendTextToGroupKeyTable(legendItem, color() || 'TWS');
      setSelectedGroupKeys((prev) => {
        const next = toggleGroupKeyInList(prev, key);
        setHasSelection(next.length > 0);
        return next;
      });
      setTriggerSelection(true);
      return;
    }

    // Use full maneuvers data for selection - don't filter by cuts when selecting
    const dataSource = maneuvers();
    if (!dataSource || !Array.isArray(dataSource) || dataSource.length === 0) {
      logDebug('FleetManeuvers: Legend click on', legendItem, '- no maneuvers data available');
      return;
    }

    const currentColorField = color();
    const clickedItem = String(legendItem);

    // Filter maneuvers by current color field matching the clicked legend item
    const legendEntryIds = dataSource
      .filter((m: any) => {
        const modeUpper = String(currentColorField || 'SOURCE').toUpperCase();

        if (currentColorField === 'GRADE') {
          const gradeValue = m.grade ?? m.Grade ?? m.GRADE;
          const clickedStr = clickedItem;
          const gradeNum = Number(gradeValue);
          const clickedNum = Number(clickedStr);
          if (!isNaN(gradeNum) && !isNaN(clickedNum) && gradeNum === clickedNum) return true;
          if (String(gradeValue) === clickedStr) return true;
          return false;
        }

        if (currentColorField === 'LEG') {
          const legValue = m.leg_number ?? m.Leg_number ?? m.LEG;
          const clickedStr = clickedItem;
          const legNum = Number(legValue);
          const clickedNum = Number(clickedStr);
          if (!isNaN(legNum) && !isNaN(clickedNum) && legNum === clickedNum) return true;
          if (String(legValue) === clickedStr) return true;
          return false;
        }

        if (currentColorField === 'TACK') {
          const tackValue = String(m.tack || '').toUpperCase();
          const clickedTack = clickedItem.toUpperCase();
          if ((tackValue === 'PORT' || tackValue === 'S - P') && (clickedTack === 'PORT' || clickedTack === 'S - P')) {
            return true;
          }
          if ((tackValue === 'STBD' || tackValue === 'P - S') && (clickedTack === 'STBD' || clickedTack === 'P - S')) {
            return true;
          }
          return false;
        }

        if (['TWS', 'RACE', 'SOURCE', 'STATE', 'CONFIG', 'TESTS', 'YEAR', 'EVENT'].includes(modeUpper)) {
          const targetKey = legendTextToGroupKeyTable(clickedItem, modeUpper);
          return groupKeyEquals(getGroupKeyFromItem(m, modeUpper), targetKey);
        }

        const fieldValueStr = m[currentColorField.toLowerCase()] ?? m[currentColorField];
        if (fieldValueStr === undefined || fieldValueStr === null) return false;
        if (String(fieldValueStr) === clickedItem) return true;
        const fieldNum = Number(fieldValueStr);
        const clickedNum = Number(clickedItem);
        if (!isNaN(fieldNum) && !isNaN(clickedNum) && fieldNum === clickedNum) return true;
        if (String(fieldValueStr).toLowerCase() === clickedItem.toLowerCase()) return true;
        return false;
      })
      .map((m: any) => m.event_id)
      .filter((id): id is number => id !== undefined && id !== null && !isNaN(Number(id)));

    if (legendEntryIds.length === 0) {
      logDebug('FleetManeuvers: Legend click on', legendItem, '- no matching event IDs found');
      requestAnimationFrame(() => trySettleLiveInteraction());
      return;
    }

    // Get current selection
    const currentSelected = selectedEvents();
    const currentSelectedSet = new Set(currentSelected);

    // Check if all legend entry IDs are already selected
    const allSelected = legendEntryIds.every(id => currentSelectedSet.has(id));

    if (allSelected) {
      // All IDs are selected → remove all legend entry IDs
      const updatedSelection = currentSelected.filter(id => !legendEntryIds.includes(id));
      if (updatedSelection.length > 0) {
        setLegendSelectionActive(true);
      }
      setSelectedEvents(updatedSelection);
      setHasSelection(updatedSelection.length > 0);
      logDebug('FleetManeuvers: Legend click on', legendItem, '- deselected all', legendEntryIds.length, 'event IDs');
    } else {
      // Not all IDs are selected → select all legend entry IDs (merge with existing)
      const updatedSelection = Array.from(new Set([...currentSelected, ...legendEntryIds]));
      setLegendSelectionActive(true);
      setSelectedEvents(updatedSelection);
      setHasSelection(updatedSelection.length > 0);
      logDebug('FleetManeuvers: Legend click on', legendItem, '- selected all', legendEntryIds.length, 'event IDs');
    }

    // Refresh selection styling without refetching timeseries data
    setTriggerSelection(true);
    requestAnimationFrame(() => trySettleLiveInteraction());
  };

  // Set dataset timezone when date changes so maneuver table datetime is in local time (dataset timezone)
  createEffect(async () => {
    const className = selectedClassName();
    const projectId = selectedProjectId();
    const date = selectedDate();

    if (!className || !projectId || !date || String(date).trim() === "") {
      await setCurrentDataset(className || "", projectId || 0, null);
      return;
    }

    try {
      const ymd = String(date).replace(/[-/]/g, "");
      const timezoneResponse = await getData(
        `${apiEndpoints.app.datasets}/date/timezone?class_name=${encodeURIComponent(className)}&project_id=${encodeURIComponent(projectId)}&date=${encodeURIComponent(ymd)}`
      );

      const timezoneData = timezoneResponse?.data || timezoneResponse || {};
      const timezone = timezoneData.timezone;
      const datasetId = timezoneData.dataset_id;

      if (timezone && datasetId) {
        await setCurrentDataset(className, projectId, datasetId);
        logDebug("FleetManeuvers: Set timezone from date endpoint for table datetime", {
          datasetId,
          timezone: getCurrentDatasetTimezone(),
        });
      } else {
        await setCurrentDataset(className, projectId, null);
      }
    } catch (error: unknown) {
      logDebug("FleetManeuvers: Error setting timezone for date", error as any);
      await setCurrentDataset(className, projectId, null);
    }
  });

  // Initialize liveSelectionSourceIds — map/perf settings first, then page-local override.
  createEffect(() => {
    const sourcesReady = sourcesStore.isReady();
    const sources = sourcesStore.sources();
    if (!sourcesReady || !sources || sources.length === 0) return;

    const validIds = projectValidSourceIds();
    if (validIds.size === 0) return;

    const existing = liveSelectionSourceIds();
    if (existing.size > 0) {
      const normalizedExisting = normalizeSourceIdSet(existing, validIds);
      const hasValid = normalizedExisting.size > 0;
      if (hasValid) {
        if (
          normalizedExisting.size !== existing.size ||
          [...normalizedExisting].some((id) => !existing.has(id))
        ) {
          setLiveSelectionSourceIds(normalizedExisting);
          persistLiveSelectionSourceIds(normalizedExisting);
        }
        return;
      }
      logDebug('LiveManeuvers: clearing stale liveSelectionSourceIds (no overlap with project sources)');
      setLiveSelectionSourceIds(new Set<number>());
    }

    const fromShared = normalizeSourceIdSet(displaySourceIds(), validIds);
    if (fromShared.size > 0) {
      applyLiveSelectionSourceIds(fromShared, 'filterStore selectedSources');
      return;
    }

    const className = (selectedClassName() || '').trim();
    const projectId = selectedProjectId();
    if (!className || projectId == null) return;

    void (async () => {
      try {
        const sharedIds = await loadSharedSourceIds();
        const fromPersisted = normalizeSourceIdSet(sharedIds, validIds);
        if (fromPersisted.size > 0 && liveSelectionSourceIds().size === 0) {
          applyLiveSelectionSourceIds(fromPersisted, 'loadSharedSourceIds');
          return;
        }
      } catch (err: unknown) {
        logDebug('LiveManeuvers: loadSharedSourceIds failed during selection init', err as Error);
      }

      try {
        const sourceNames = await initializeSourceSelections();
        const fromNames = sourceIdsFromNames(sourceNames);
        const fromInit = normalizeSourceIdSet(fromNames, validIds);
        if (fromInit.size > 0 && liveSelectionSourceIds().size === 0) {
          applyLiveSelectionSourceIds(fromInit, 'initializeSourceSelections');
          return;
        }
      } catch (err: unknown) {
        logDebug('LiveManeuvers: initializeSourceSelections failed during selection init', err as Error);
      }

      const stored = getStoredLiveManeuverSelectionSources(className, projectId);
      if (stored && stored.length > 0 && liveSelectionSourceIds().size === 0) {
        const fromStored = normalizeSourceIdSet(stored, validIds);
        if (fromStored.size > 0) {
          applyLiveSelectionSourceIds(fromStored, 'liveManeuverSelectionSources localStorage');
          return;
        }
      }

      if (liveSelectionSourceIds().size === 0) {
        applyLiveSelectionSourceIds(new Set(validIds), 'all project sources');
      }
    })();
  });

  // When the shared selection loads after mount, seed selection sources if still empty.
  createEffect(() => {
    if (!sourcesStore.isReady() || projectValidSourceIds().size === 0) return;
    if (liveSelectionSourceIds().size > 0) return;

    const fromShared = normalizeSourceIdSet(displaySourceIds(), projectValidSourceIds());
    if (fromShared.size > 0) {
      applyLiveSelectionSourceIds(fromShared, 'filterStore selectedSources (late)');
    }
  });

  // Follow state now lives in playbackStore `liveManeuverFollow` (this page's own switch, default
  // ON); no per-project localStorage seeding needed.

  // When streaming/simulation starts after mount, ensure LIVE rows then refetch.
  createEffect(
    on(
      () => streamingStatusStore.status()().isLiveDatasetVisible,
      (active, prev) => {
        if (!liveMountComplete() || !active || prev === active) return;
        void (async () => {
          liveDatasetsEnsuredAt = 0;
          await ensureLiveDatasetsForSession();
          runImmediateLiveTableFetch();
        })();
      },
      { defer: true }
    )
  );

  // When project sources finish loading after mount, trigger the first table fetch.
  createEffect(
    on(
      () => ({
        mount: liveMountComplete(),
        ready: sourcesStore.isReady(),
        nsrc: sourcesStore.sources()?.length ?? 0,
      }),
      (cur, prev) => {
        if (!cur.mount || !cur.ready || cur.nsrc === 0) return;
        if (prev?.ready && (prev?.nsrc ?? 0) > 0) return;
        runImmediateLiveTableFetch();
      },
      { defer: true }
    )
  );

  // One debounced table refetch for: date, maneuver type, selected sources, training/racing. Waits until onMount
  // applied project filters so we do not race effects against loadFiltersFromPersistentSettings / getProjectManeuverFilters.
  createEffect(
    on(
      () => {
        const sources = sourcesStore.sources() ?? [];
        const allIds = sources
          .map((s: { source_id?: number }) => s.source_id)
          .filter((id: unknown): id is number => typeof id === 'number' && id > 0)
          .sort((a, b) => a - b);
        const sel = displaySourceIds();
        const isAll =
          sel.size === 0 ||
          (allIds.length > 0 &&
            sel.size === allIds.length &&
            allIds.every((id) => sel.has(id)));
        const selKey = isAll ? '__ALL__' : [...sel].sort((a, b) => a - b).join(',');

        return {
          mount: liveMountComplete(),
          mapAll: mapAllOnly(),
          solo: soloViewName(),
          et: normalizeManeuverEventType(eventType()),
          date: getLiveManeuverQueryDateYmd(),
          ready: sourcesStore.isReady(),
          nsrc: sources.length,
          selKey,
          tr: maneuverTrainingRacing(),
          gradesKey: [...selectedGrades()].sort((a, b) => a - b).join(','),
          statesKey: [...selectedStates()].sort().join(','),
        };
      },
      (cur, prev) => {
        if (!cur.mount) return;
        if (!cur.ready || cur.nsrc === 0 || !cur.date || !cur.et) {
          logDebug('LiveManeuvers: table fetch effect waiting', cur);
          return;
        }

        if (prev?.mount && prev.mapAll && !cur.mapAll && untrack(() => maneuvers().length) > 0) {
          logDebug('LiveManeuvers: MAP ALL -> solo view, refilter only');
          filterData();
          return;
        }

        const payload = {
          mapAll: cur.mapAll,
          solo: cur.solo,
          et: cur.et,
          date: cur.date,
          selKey: cur.selKey,
          tr: cur.tr,
          gradesKey: cur.gradesKey,
          statesKey: cur.statesKey,
        };
        const prevPayload =
          prev && prev.mount
            ? {
                mapAll: prev.mapAll,
                solo: prev.solo,
                et: prev.et,
                date: prev.date,
                selKey: prev.selKey,
                tr: prev.tr,
                gradesKey: prev.gradesKey,
                statesKey: prev.statesKey,
              }
            : null;
        if (prevPayload && JSON.stringify(payload) === JSON.stringify(prevPayload)) return;

        scheduleLiveTableFetch();
      },
      { defer: true }
    )
  );

  // Sync view-load pause for TABLE / SCATTER (no async panel loading callbacks).
  createEffect(() => {
    const active = getActiveViewName();
    if (active !== 'TABLE' && active !== 'SCATTER') return;
    if (!liveTableLoadSettled()) {
      syncAggregateViewLoading(true);
      return;
    }
    requestAnimationFrame(() => {
      syncAggregateViewLoading(false);
    });
  });

  // Pause merge polls during live submenu / host-mode changes until active view settles.
  createEffect(
    on(
      () => ({
        mount: liveMountComplete(),
        mapAll: mapAllOnly(),
        solo: soloViewName(),
      }),
      (cur, prev) => {
        if (!cur.mount || !prev?.mount) return;
        if (cur.mapAll === prev.mapAll && cur.solo === prev.solo) return;
        pauseLiveInteraction('submenu-view-change');
        if (!liveInitialLoadDone) {
          runImmediateLiveTableFetch();
          return;
        }

        if (!prev.mapAll && cur.mapAll) {
          logDebug('LiveManeuvers: submenu -> MAP ALL, fetching all maneuver types');
          runImmediateLiveTableFetch();
          return;
        }

        if (prev.mapAll && !cur.mapAll && untrack(() => maneuvers().length) > 0) {
          logDebug('LiveManeuvers: submenu MAP ALL -> solo, refilter only');
          filterData();
          return;
        }
      }
    )
  );

  // React to cut events - refilter when cut state or cut payload changes
  createEffect(on([isCut, cutEvents], () => {
    if (untrack(() => maneuvers().length > 0)) {
      filterData();
    }
  }));

  // React to filter changes - refilter client-side when data already loaded; server refetch via unified effect (gradesKey/statesKey).
  createEffect(on([selectedGrades, selectedStates, selectedRaces, selectedLegs, maneuverTackEntry], () => {
    if (!liveMountComplete()) return;
    pauseLiveInteraction('filters');
    if (untrack(() => maneuvers().length > 0)) {
      filterData();
    }
  }));

  createEffect(on(maneuverTableSort, () => {
    if (!liveMountComplete()) return;
    pauseLiveInteraction('table-sort');
    if (untrack(() => maneuvers().length > 0)) {
      filterData();
    }
  }));

  // Training/racing is included in the unified fleet table fetch effect (tr in payload).

  // React to view and data: map/table layout is inside Show when filtered maneuvers exist, so we must
  // re-measure after async fetch (dataset Maneuvers runs fetch before first updateContainerHeights in onMount).
  createEffect(() => {
    view();
    filtered().length;
    tabledata().length;
    maneuvers().length;
    mapAllOnly();
    soloViewName();
    showTimeline();
    showSelectionTimelineStrip();
    // Colour mode changes the legend's wrapped height, so re-measure on it too.
    color();
    maneuverColorLegendItems().length;
    // Delegate to updateContainerHeights rather than repeating its arithmetic: this effect used to
    // carry a second copy, so anything added to the reserve there (e.g. the color legend row) was
    // silently overwritten here a tick later.
    setTimeout(() => {
      updateContainerHeights();
    }, 0);
  });

  createEffect(() => {
    const eventList = selectedEvents();
    if (eventList.length === 0) return;

    // Skip fetching times in fleet context - the /api/events/times endpoint requires dataset_id
    // and doesn't support fleet context (source_id + date). Time ranges are not critical for
    // fleet maneuvers - they're mainly used for highlighting selected events.
    const datasetId = selectedDatasetId();
    if (!datasetId || datasetId <= 0) {
      logDebug('FleetManeuvers: Skipping times fetch in fleet context (endpoint requires dataset_id)');
      return;
    }

    if (timesController) {
      timesController.abort();
    }

    timesController = new AbortController();
    const signal = timesController.signal;
    const className = selectedClassName();
    const projectId = selectedProjectId();

    void runEventTimesSelectionSync({
      fetchTimes: () =>
        getEventTimes(
          {
            class_name: className,
            project_id: projectId,
            dataset_id: datasetId,
            event_list: eventList,
          },
          signal
        ),
      applySelection: (result) => {
        setSelection((result as { data?: unknown }).data);
      },
    }).finally(() => {
      timesController = null;
    });
  });

  // THE LIVE MAP IS AUTONOMOUS — this page does not write `selectedRanges`.
  //
  // There used to be an effect here that built ranges from the maneuver event times and published
  // them to the selection store, so a live map open beside this page in split view would draw and
  // zoom to whatever was selected in the table. That is not what the live map is for: unlike the
  // fleet and explore maps it runs on its own clock against the stream, and a table selection
  // dragging its track and timeline around is exactly the interference we want gone. The only
  // crossing that remains is the intended one — clicking a maneuver ON the map opens that
  // maneuver's report.
  //
  // Cutting still works with `selectedRanges` empty: `cutSelection` takes its event-id path, the
  // same one the fleet and history maneuver pages use.
  //
  // The day/dataset performance and maneuver pages keep writing `selectedRanges` — this rule is
  // about the live map only.

  const sortedEventIdsEqual = (a: unknown[], b: number[]): boolean => {
    if (!Array.isArray(a) || a.length !== b.length) return false;
    const toId = (x: unknown) => (typeof x === 'number' ? x : (x as { event_id?: number })?.event_id);
    const numsA = a.map(toId).filter((id): id is number => typeof id === 'number' && id > 0).sort((x, y) => x - y);
    const numsB = [...b].filter((id): id is number => typeof id === 'number' && id > 0).sort((x, y) => x - y);
    if (numsA.length !== numsB.length) return false;
    return numsA.every((v, i) => v === numsB[i]);
  };

  /**
   * Selecting maneuvers by hand pauses the live follow, so the auto-follow highlight stops moving off
   * the maneuvers the user just picked. Selecting is a deliberate "I am looking at THESE", which is
   * incompatible with chasing the edge, so it counts as a user gesture on the transport.
   *
   * `setLiveManeuverFollow`, and NOT the clock (and NOT Performance's switch): the page's visible
   * control is <LiveFollowToggle scope="report" page="maneuver"/>, so the auto-pause has to land in
   * exactly the state pressing that button gives. Writing the clock instead would freeze the live
   * map sitting beside this page in split view — picking a maneuver is not a statement about whether
   * the boat should keep moving, or whether Performance should keep following.
   *
   * Only ever pauses, never resumes: nothing here re-arms follow when the selection is cleared,
   * because the user may have cleared it for a reason unrelated to the transport. The toggle is right
   * there, and it flipping is the feedback that says why the updates stopped.
   *
   * Three guards, all load-bearing, because `selectedEvents` is a createSyncSignal — broadcast
   * between windows AND re-hydrated from storage, so it changes for reasons that are not a gesture
   * here:
   *
   * - `liveInitialLoadDone`: a selection left over from a previous visit arrives on its own during
   *   startup. Ungated, the page would open already paused with nothing on screen explaining why.
   * - `document.hasFocus()`: a sibling window (a maneuver report popup writing the shared selection
   *   as it loads) broadcasts straight back here. A local click happens while this window has focus;
   *   another window's write-back does not, and that is the difference.
   * - an empty `ids` is a CLEAR, not a selection gesture — and clearing is what the type/TWS
   *   switches do.
   *
   * Unlike Alinghi there is no stored auto-update preference to protect here (that localStorage flag
   * was retired when the follow signal became the single source of truth), so this needs no
   * "was it the user or was it me" flag to decide what gets persisted.
   */
  createEffect(
    on(
      selectedEvents,
      (ids, prevIds) => {
        if (!liveMode() || !liveManeuverFollowActive()) { return; }
        if (!liveInitialLoadDone) { return; }
        if (typeof document !== 'undefined' && !document.hasFocus()) { return; }
        const next = Array.isArray(ids) ? ids : [];
        if (next.length === 0) { return; }
        if (Array.isArray(prevIds) && sortedEventIdsEqual(prevIds, next as number[])) { return; }
        setLiveManeuverFollow(false);
      },
      { defer: true }
    )
  );

  // Function to sync table height with map SVG height
  const syncTableHeightWithMap = (): void => {
    if (view() !== 'MAP') return;

    const mapElement = document.querySelector('#maneuver-map') as HTMLElement | null;
    const tableArea = document.getElementById('table-area') as HTMLElement | null;

    if (mapElement && tableArea) {
      // Get the actual height of the map element (including SVG)
      const mapHeight = mapElement.offsetHeight || mapElement.clientHeight;

      // Set table area to match map height
      if (mapHeight > 0) {
        tableArea.style.height = `${mapHeight}px`;
        tableArea.style.minHeight = `${mapHeight}px`;
      }
    }
  };

  // Function to update container heights based on actual viewport (full screen)
  const updateContainerHeights = (): void => {
    // Reserve strip height when timeline is on and filtered table has rows (matches history page)
    const headerHeight = 58;
    const timelineOn = showSelectionTimelineStrip();

    // Solo popouts hide the header band and the strip, so they reserve almost nothing.
    // Measured, not a constant: the legend row wraps to a different height per colour mode.
    const legendReservePx = maneuverColorLegendReservePx();

    const additionalSpacingForMap = (soloMode() ? 16 : timelineOn ? 218 : -50) + legendReservePx;
    const mapHeight = window.innerHeight - headerHeight - additionalSpacingForMap;

    const additionalSpacingForTable = (timelineOn ? 248 : 128) + legendReservePx;
    const tableHeight = window.innerHeight - headerHeight - additionalSpacingForTable;

    const mapLayout = document.querySelector('.maneuver-map-layout') as HTMLElement | null;
    const allGrid = document.getElementById('live-maneuvers-all-grid') as HTMLElement | null;
    const tableWrapper = document.getElementById('datatable-big-wrapper') as HTMLElement | null;

    if (allGrid && mapAllOnly()) {
      allGrid.style.height = `${mapHeight}px`;
      allGrid.style.minHeight = `${mapHeight}px`;
      allGrid.style.maxHeight = `${mapHeight}px`;
    }

    if (mapLayout) {
      mapLayout.style.height = `${mapHeight}px`;
      mapLayout.style.minHeight = `${mapHeight}px`;
      mapLayout.style.maxHeight = `${mapHeight}px`;
    }

    if (tableWrapper) {
      tableWrapper.style.height = `${tableHeight}px`;
      tableWrapper.style.maxHeight = `${tableHeight}px`;
      tableWrapper.style.overflow = 'hidden';
    }

    setTimeout(() => {
      if (view() === 'MAP') syncTableHeightWithMap();
    }, 100);
  };

  // Function to observe sidebar for collapse/expand changes
  const observeSidebar = (): MutationObserver | null => {
    const sidebar = document.querySelector('.sidebar');
    if (!sidebar) return null;

    const observer = new MutationObserver(() => {
      // When sidebar class changes (collapsed/expanded), update heights
      updateContainerHeights();
    });

    observer.observe(sidebar, {
      attributes: true,
      attributeFilter: ['class']
    });

    return observer;
  };

  onMount(async () => {
    // Teardown holders + onCleanup are registered synchronously, BEFORE the first await below.
    // Solid only has an owner synchronously, so an onCleanup placed next to the resources (which
    // are created after three awaits) silently never runs — and the disposer this function used to
    // `return` was discarded outright, because Solid ignores onMount return values. The result was
    // one leaked scaling teardown, two ResizeObservers, a MutationObserver, a 100 ms interval and
    // two window listeners per mount.
    let cleanupScaling: (() => void) | null = null;
    let resizeObserver: ResizeObserver | null = null;
    let mapObserver: ResizeObserver | null = null;
    let sidebarObserver: MutationObserver | null = null;
    let sidebarCheckInterval: ReturnType<typeof setInterval> | null = null;
    let handleResize: (() => void) | null = null;
    let handleKeyDown: ((event: KeyboardEvent) => void) | null = null;

    onCleanup(() => {
      // The live-state resets (unregisterLiveManeuverUpdateGate / resetLiveUpdateLifecycle /
      // clearLiveNewRowHighlights) are deliberately NOT repeated here — the component-level
      // onCleanup below already performs them, and it always runs.
      cleanupScaling?.();
      resizeObserver?.disconnect();
      mapObserver?.disconnect();
      sidebarObserver?.disconnect();
      if (sidebarCheckInterval) clearInterval(sidebarCheckInterval);
      if (handleResize) window.removeEventListener('resize', handleResize);
      if (handleKeyDown) window.removeEventListener('keydown', handleKeyDown);
    });

    setManeuvers([]);
    setTableData([]);
    setFiltered([]);
    // Reset THIS page's own selection on mount. `setSelectedEvents([])` touches only the maneuver
    // domain, so opening this page into a split beside Live Performance no longer wipes a selection
    // made there. `setHasSelection` is deliberately NOT written here: it is shared with the aggregate
    // domain, and the store recomputes it from both.
    setSelectedEvents([]);
    setSelection([]);
    applyLiveManeuverTableSortDefault();

    await logPageLoad('LiveManeuvers.tsx', 'Live Maneuvers Report');

    try {
      await sourcesStore.refresh();
    } catch (err: unknown) {
      logError('LiveManeuvers: sourcesStore.refresh failed', err as Error);
    }

    const queryDate = getLiveManeuverQueryDateYmd();
    if (!(selectedDate() || '').trim() || selectedDate() === '0') {
      setSelectedDate(queryDate);
      logDebug('LiveManeuvers: set selectedDate for LIVE maneuver query', queryDate);
    }

    // Set default color to SOURCE for fleet context; default TWS to ALL
    setColor('SOURCE');
    setEventType(DEFAULT_LIVE_MANEUVER_EVENT_TYPE);
    setView(soloViewName() ?? 'MAP');
    setTws('ALL');

    const filtersLoaded = await loadFiltersFromPersistentSettings();
    if (!filtersLoaded) {
      applyLiveManeuverFilterDefaults();
      logDebug('LiveManeuvers: No saved maneuver filters — applied live defaults');
    } else {
      ensureLiveManeuverFilterOptionBaselines();
    }
    applyLiveManeuverTableSortDefault();

    // Merge polls start after the first successful full fetch (afterNonMergeTableFetchComplete).

    // Allow the single unified createEffect to run (debounced); avoids overlapping fetches with effects during this async onMount.
    setLiveMountComplete(true);
    ensureLiveManeuverFilterOptionBaselines();
    void refreshManeuverStateOptions(
      mapAllOnly()
        ? DEFAULT_LIVE_MANEUVER_EVENT_TYPE
        : (eventType() || DEFAULT_LIVE_MANEUVER_EVENT_TYPE).trim() || DEFAULT_LIVE_MANEUVER_EVENT_TYPE
    );
    runImmediateLiveTableFetch();

    logInfo('LiveManeuvers: page ready — initial fetch immediate, merge polls after first load');

    // Set up dynamic scaling for media-container using the global utility
    cleanupScaling = setupMediaContainerScaling({
      logPrefix: 'LiveManeuvers',
      getMediaContainer: () => mediaContainerRef ?? null
    });

    // Set initial heights
    updateContainerHeights();

    // Update heights on container resize (scaling is handled by setupMediaContainerScaling)
    resizeObserver = new ResizeObserver(() => {
      updateContainerHeights();
    });

    // Observe map element to sync table height when map resizes
    mapObserver = new ResizeObserver(() => {
      if (view() === 'MAP') {
        syncTableHeightWithMap();
      }
    });

    const mediaContainer = mediaContainerRef ?? document.getElementById('media-container');
    if (mediaContainer) {
      // Observe the appropriate reference container (split panel or parent)
      const splitPanel = mediaContainer.closest('.split-panel');
      const mainContent = mediaContainer.closest('#main-content');
      const reference = splitPanel || mainContent || mediaContainer.parentElement;
      if (reference) {
        resizeObserver.observe(reference);
      }
    }

    // Observe map element for height changes
    const mapElement = document.querySelector('#maneuver-map');
    if (mapElement) {
      mapObserver.observe(mapElement);
    }

    // Also observe map area container
    const mapArea = document.getElementById('map-area');
    if (mapArea) {
      mapObserver.observe(mapArea);
    }

    // Observe sidebar for collapse/expand changes
    sidebarObserver = observeSidebar();

    // Poll for sidebar changes (since same-tab localStorage changes don't trigger storage event)
    sidebarCheckInterval = setInterval(() => {
      const sidebar = document.querySelector('.sidebar');
      if (sidebar) {
        const isCollapsed = sidebar.classList.contains('collapsed');
        const wasCollapsed = localStorage.getItem('_sidebarWasCollapsed') === 'true';
        if (isCollapsed !== wasCollapsed) {
          localStorage.setItem('_sidebarWasCollapsed', isCollapsed.toString());
          updateContainerHeights();
        }
      }
    }, 100);

    // Also listen to window resize for when the main window changes size
    handleResize = (): void => {
      updateContainerHeights();
    };
    window.addEventListener('resize', handleResize);

    // 'h' key: Hide selected events; 'x' clear; 'c' cut
    handleKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement | null;
      if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable)) return;
      if (document.querySelector('.pagesettings-modal')) return;

      if (event.key === 'x' || event.key === 'X') {
        event.preventDefault();
        logDebug('LiveManeuvers: Clearing selection (x key pressed)');
        clearSelection();
        requestAnimationFrame(() => setTriggerUpdate(true));
        return;
      }

      if (event.key === 'c' || event.key === 'C') {
        event.preventDefault();
        const currentSelected = selectedEvents();
        if (currentSelected && currentSelected.length > 0) {
          logDebug('LiveManeuvers: Cutting selection (c key pressed)');
          cutSelection();
          requestAnimationFrame(() => setTriggerUpdate(true));
        }
        return;
      }

      if (event.key === 'h' || event.key === 'H') {
        const currentSelected = selectedEvents();
        if (currentSelected && currentSelected.length > 0) {
          event.preventDefault();
          hideSelectedEvents();
          requestAnimationFrame(() => setTriggerUpdate(true));
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    // Teardown is registered by the onCleanup at the top of this onMount (see the note there).
  });

  /**
   * Publish the newest maneuver on the plot, for the header's data-age badge.
   *
   * This page polls Postgres for graded maneuvers rather than riding the telemetry stream, so nothing
   * else on screen says whether grading is still happening. Reads the rows the page actually shows,
   * not the fetch response, so the badge answers "how old is what I am looking at".
   */
  createEffect(() => {
    const rows = (maneuvers() ?? []) as Record<string, unknown>[];
    let newest = 0;
    for (const row of rows) {
      const ms = getManeuverRowTimeMs(row);
      if (ms > newest) { newest = ms; }
    }
    setLiveReportEdge(newest > 0 ? { atMs: newest, what: 'maneuver', label: 'last maneuver' } : null);
  });

  onCleanup(() => clearLiveReportEdge('maneuver'));

  /**
   * Stall watchdog: a leaked pause, or a request that never settles, must not cost the whole session.
   *
   * Its own timer, deliberately — the merge timer is the thing that stops when a pause leaks, so it
   * can never be what notices. The rule itself lives in `utils/liveStallWatchdog.ts` (pure, tested);
   * everything reactive or imperative is here.
   *
   * It also force-clears `aggregateViewLoading`, which gates `maybeFlushPendingMergePoll` outside the
   * coordinator's pause counts and so would survive a `releaseAllPauses` on its own.
   *
   * Two things it must never do: run while the user has Follow off (that is a pause they chose), and
   * touch the transport. It restarts machinery, it does not express intent.
   */
  let liveStallCheckId: ReturnType<typeof setInterval> | null = null;

  const runLiveStallCheck = (): void => {
    const state = pollCoordinator.getState();
    const now = Date.now();
    const stalled = shouldForceReleaseLiveLoop({
      live: liveMode(),
      following: liveManeuverFollowActive(),
      initialLoadDone: state.initialLoadDone,
      fetchInFlight: tableFetchInFlight,
      fetchInFlightForMs: tableFetchInFlight && tableFetchStartedAt > 0 ? now - tableFetchStartedAt : 0,
      stalledForMs: now - lastLiveProgressAt,
      thresholdMs: resolveLiveStallThresholdMs(livePollIntervalMs),
    });
    if (!stalled) { return; }
    syncAggregateViewLoading(false);
    markLiveProgress();
    // Following is true here (stall gate), so no held follow pause is the correct steady state.
    followPauseHeld = false;
    pollCoordinator.releaseAllPauses();
  };

  onMount(() => {
    liveStallCheckId = setInterval(runLiveStallCheck, LIVE_STALL_CHECK_MS);
    onCleanup(() => {
      if (liveStallCheckId) {
        clearInterval(liveStallCheckId);
        liveStallCheckId = null;
      }
    });
  });

  /**
   * Re-assert live mode when this tab is live but the shared flag has been turned off.
   *
   * `liveMode` is a createSyncSignal, so another window can clear it; this page has NO MapContainer,
   * so it can never defend itself through the live-map refcount in `utils/liveScope.ts`. Every gate
   * on this page reads `liveMode()`, and nothing on that path writes the Follow switch, so the toggle
   * goes on saying LIVE over a dead loop.
   *
   * Deliberately NOT gated on `liveManeuverFollow()`: pressing pause on a table is not a statement
   * about whether the app is in live mode. It IS gated on this tab believing it is live, which is the
   * per-tab fact no other window can rewrite.
   */
  createEffect(() => {
    if (liveMode()) { return; }
    if (!isLivePageActive()) { return; }
    logDebug('LiveManeuvers: live mode was cleared while this tab is live - re-asserting');
    setLiveMode(true);
  });

  // Cleanup abort controllers and other resources on component unmount
  onCleanup(() => {
    unregisterLiveManeuverUpdateGate();
    if (liveTableFetchDebounce) {
      clearTimeout(liveTableFetchDebounce);
      liveTableFetchDebounce = null;
    }
    resetLiveUpdateLifecycle();
    clearLiveNewRowHighlights();
    // Abort any pending table data requests
    if (tableDataController) {
      tableDataController.abort();
      tableDataController = null;
    }

    // Abort any pending times requests
    if (timesController) {
      timesController.abort();
      timesController = null;
    }

    // Clear any stored data to free memory
    setManeuvers([]);
    setTableData([]);
    setFiltered([]);
    livePollIndicatorCount = 0;
    setLiveManeuverPollActive(false);

    logDebug('LiveManeuvers: Cleanup complete - abort controllers cleared and data reset');
  });

  const livePanelProps = (panelView: string) => ({
    panelActive: () => {
      if (mapAllOnly()) return false;
      if (soloMode()) return !soloViewPanelHidden(panelView);
      return view() === panelView;
    },
    onLoadStateChange: handlePanelLoadStateChange,
  });

  /**
   * The MAP side-panel chart is a second TimeSeries instance on this page, so it must stay inert
   * unless the MAP panel is visible AND showing the chart — otherwise it polls behind a hidden
   * panel. Deliberately no onLoadStateChange: the TIME SERIES panel owns the poll gate.
   */
  const mapSidePanelChartActive = (): boolean =>
    livePanelProps('MAP').panelActive() && mapSidePanel() === 'CHART';

  const toggleRaceFilter = (race: number | string) => {
    pauseLiveInteraction('race-filter');
    const current = selectedRaces();
    const next = current.includes(race) ? current.filter(r => r !== race) : [...current, race];
    setSelectedRaces(next);
    setSelectedRacesManeuvers(next.map(r => String(r)));
  };

  const toggleLegFilter = (leg: number) => {
    pauseLiveInteraction('leg-filter');
    const current = selectedLegs();
    const next = current.includes(leg) ? current.filter(l => l !== leg) : [...current, leg];
    setSelectedLegs(next);
    setSelectedLegsManeuvers(next.map(l => String(l)));
  };

  const toggleGradeFilter = (grade: number) => {
    pauseLiveInteraction('grade-filter');
    const current = selectedGrades();
    const next = current.includes(grade) ? [] : [grade];
    setSelectedGrades(next);
    setSelectedGradesManeuvers(next.map(g => String(g)));
  };

  const toggleStateFilter = (state: string) => {
    pauseLiveInteraction('state-filter');
    const current = selectedStates();
    const next = current.includes(state) ? current.filter(s => s !== state) : [...current, state];
    setSelectedStates(next);
    setSelectedStatesManeuvers(next);
  };

  createEffect(() => {
    const rLocal = raceOptions().map((x) => String(x));
    const lLocal = legOptions().map((x) => String(x));
    const gLocal = gradeOptions().map((x) => String(x));
    const rs = storeRaceOptions().map((x) => String(x));
    const ls = storeLegOptions().map((x) => String(x));
    const gs = storeGradeOptions().map((x) => String(x));
    if (JSON.stringify([...rLocal].sort()) !== JSON.stringify([...rs].sort())) {
      pushRaceOptionsToFilterStore(rLocal);
    }
    if (JSON.stringify([...lLocal].sort()) !== JSON.stringify([...ls].sort())) {
      pushLegOptionsToFilterStore(lLocal);
    }
    if (JSON.stringify([...gLocal].sort()) !== JSON.stringify([...gs].sort())) {
      pushGradeOptionsToFilterStore(gLocal);
    }
  });

  // Selection sources for ManeuverSettings (page-local auto-select scope).
  const dataSourcesOptions = createMemo(() => {
    return (sourcesStore.sources() ?? [])
      .map((source: { source_id?: number; source_name?: string }) => {
        const sourceId = Number(source.source_id);
        if (!Number.isFinite(sourceId) || sourceId <= 0) return null;
        return {
          key: `source-${sourceId}`,
          label: source.source_name,
          signal: [
            () => liveSelectionSourceIds().has(sourceId),
            (value: boolean) => {
              pauseLiveInteraction('source-filter');
              const current = liveSelectionSourceIds();
              const next = new Set(current);
              if (value) {
                next.add(sourceId);
              } else {
                next.delete(sourceId);
              }
              setLiveSelectionSourceIds(next);
              persistLiveSelectionSourceIds(next);
              syncLiveSelectionToLatestPerSource(
                untrack(() => maneuvers()) as Record<string, unknown>[],
                { replaceAll: true, force: true }
              );
            },
          ] as [() => boolean, (value: boolean) => void],
        };
      })
      .filter((opt): opt is NonNullable<typeof opt> => opt !== null);
  });

  const renderLiveManeuverSettings = () => (
    <ManeuverSettings
      useIconTrigger={true}
      isHistoryPage={false}
      raceOptions={raceOptions()}
      legOptions={legOptions()}
      gradeOptions={() => gradeOptions()}
      stateOptions={() => stateOptions()}
      selectedRaces={() => selectedRaces()}
      selectedLegs={() => selectedLegs()}
      selectedGrades={() => selectedGrades()}
      selectedStates={() => selectedStates()}
      selectedTrainingRacing={maneuverTrainingRacing()}
      onTrainingRacingFilterChange={(val) => {
        pauseLiveInteraction('training-racing');
        setManeuverTrainingRacing(val);
      }}
      selectedTackEntry={maneuverTackEntry()}
      onTackEntryFilterChange={(val) => {
        pauseLiveInteraction('tack-entry');
        setManeuverTackEntry(val);
      }}
      setRaceOptions={setRaceOptions}
      setLegOptions={setLegOptions}
      setGradeOptions={setGradeOptions}
      setStateOptions={setStateOptions}
      toggleRaceFilter={toggleRaceFilter}
      toggleLegFilter={toggleLegFilter}
      toggleGradeFilter={toggleGradeFilter}
      toggleStateFilter={toggleStateFilter}
      onApplyFilters={() => {
        pauseLiveInteraction('apply-filters');
        cachedPersistentManeuverFilters = snapshotLiveManeuverFiltersFromPage();
        // Debounced so that an Apply carrying both filter and time-window changes issues one
        // request, not one per callback. See handleTimeWindowChange.
        scheduleLiveTableFetch();
      }}
      useUnfilteredOptions={true}
      includeAllGradeOption={true}
      dataSourcesOptions={dataSourcesOptions()}
      dataSourcesTitle="Selection Sources"
      dataSourcesHelpText="Mirrors live map / performance source selection by default. Controls which sources are auto-selected when new live maneuvers arrive."
      persistSourcesToFleetSettings={false}
      showTimeline={() => showTimeline()}
      onTimelineChange={handleTimelineChange}
      liveTimeWindowMinutes={() => timeWindowMinutes()}
      onLiveTimeWindowChange={handleTimeWindowChange}
      componentConfig={{
        showGrades: true,
        showRaces: true,
        showLegs: true,
        showStates: true,
        showTackEntry: true,
      }}
    />
  );

  return (
    <div
      ref={mediaContainerRef}
      id="media-container"
      class={`maneuvers-page${mapAllOnly() ? ' maneuvers-page--live-map-all-window' : soloViewName() ? ' maneuvers-page--live-solo-window' : ''}${!soloMode() && showSelectionTimelineStrip() ? ' maneuvers-page--with-selection-timeline' : ''}`}
      data-live-maneuvers-page
    >
      <LiveManeuversPollStatus active={liveManeuverPollActive} />
      <div class="container">
        <Show when={soloMode()}>
          <div class="live-maneuver-solo-toolbar" id="maneuver-controls-solo">
            {renderLiveManeuverSettings()}
            <div class="maneuver-panel-filter-summary live-maneuver-solo-toolbar__filters">
              <PerformanceFilterSummary
                filterGrades={selectedGrades().join(',')}
                filterState={selectedStates().join(',')}
                stateOptions={stateOptions()}
                trainingRacing={maneuverTrainingRacing()}
                tackEntry={maneuverTackEntry()}
                gradeAsGreaterThan
              />
            </div>
          </div>
          <Show when={hasFilteredManeuvers() && maneuverColorLegendItems().length > 0}>
            <div
              id="maneuver-color-legend-row"
              class="maneuver-color-legend-row"
              ref={setLegendRowEl}
            >
              <ManeuverColorLegend
                colorMode={color()}
                items={maneuverColorLegendItems()}
                onItemClick={handleLegendClick}
              />
            </div>
          </Show>
        </Show>
        <Show when={!soloMode()}>
          {/* Controls always visible so user can change filters even when no data */}
          <div id="maneuver-controls" class="flex flex-col w-full pl-2 pt-2">
          {/* Top Control Bar: single row */}
          <div class="maneuver-control-bar-row flex w-full h-[50px] items-center gap-x-2">
            {/* Left group: 4 buttons */}
            <div class="flex gap-x-2 items-center flex-shrink-0">
              <div class="self-center">
                {renderLiveManeuverSettings()}
              </div>
              <DropDownButton
                options={eventTypes()}
                defaultText={eventType()}
                smallLabel="Maneuver"
                size="big"
                handleSelection={handleEventType}
              />
              <DropDownButton
                options={viewOptions()}
                defaultText={grouped() && view() === 'SCATTER' ? 'BOXES' : view()}
                smallLabel="View"
                size="big"
                handleSelection={handleView}
              />
              <Show when={view() === 'TIME SERIES' || view() === 'MAP'}>
                <DropDownButton
                  options={phases()}
                  defaultText={phase()}
                  smallLabel="Phase"
                  size="big"
                  handleSelection={handlePhase}
                />
              </Show>
              {/* Active Filters: right side of left button area */}
              <div class="maneuver-panel-filter-summary">
                <PerformanceFilterSummary
                  filterGrades={selectedGrades().join(",")}
                  filterState={selectedStates().join(",")}
                  stateOptions={stateOptions()}
                  trainingRacing={maneuverTrainingRacing()}
                  tackEntry={maneuverTackEntry()}
                  gradeAsGreaterThan
                />
              </div>
            </div>

            {/* Right button area: TWS, Grouped, Data, Color By (unchanged) */}
            <div class="maneuver-control-bar-right flex gap-x-2 items-center ml-auto flex-shrink-0">
              <DropDownButton
                options={twsoptions()}
                defaultText={tws()}
                smallLabel="Tws"
                size="small"
                handleSelection={handleTws}
              />
              <DropDownButton
                options={groupedOptions()}
                defaultText={groupDisplayMode()}
                smallLabel="Group"
                size="small"
                handleSelection={(val) => {
                  pauseLiveInteraction('grouped');
                  setGroupDisplayMode(val);
                  setTriggerUpdate(true);
                }}
              />
              <Show when={view() === 'MAP' || view() === 'TIME SERIES' || view() === 'SCATTER'}>
                <DropDownButton
                  options={colors()}
                  defaultText={color()}
                  smallLabel="Color By"
                  size="big"
                  handleSelection={handleColor}
                />
              </Show>
              <Show when={!mapAllOnly()}>
                <LiveFollowToggle scope="report" page="maneuver" />
              </Show>
            </div>
          </div>

          <Show when={showSelectionTimelineStrip()}>
            <div class="maneuver-selection-timeline">
              <ScatterTimeseries
                // Deliberately excludes the point count: ScatterTimeseries rebuilds when `key`
                // changes and a rebuild clears the brush, which publishes an empty selection and
                // wipes a manual pick. Same rule as LiveFleetSummary's timeline key.
                key={`fleet-maneuver-tl-${color()}-${tws()}-${eventType()}`}
                aggregates={maneuverTimelinePoints()}
                color={color()}
                groups={maneuverTimelineGroups()}
                isHistoryPage={false}
                showUwDw={false}
                skipSelectedSourcesFilter={true}
                colorScale={
                  color() === 'SOURCE' && fleetManeuverSourceColorScale()
                    ? (source: string) => String(fleetManeuverSourceColorScale()!(source))
                    : undefined
                }
              />
            </div>
          </Show>
          {/* Shared color-by legend for all views. Deliberately outside the strip's Show: it
              stays visible when the Timeline toggle is off, so MAP/TABLE keep their legend. */}
          <Show when={hasFilteredManeuvers() && maneuverColorLegendItems().length > 0}>
            <div
              id="maneuver-color-legend-row"
              class="maneuver-color-legend-row"
              ref={setLegendRowEl}
            >
              <ManeuverColorLegend
                colorMode={color()}
                items={maneuverColorLegendItems()}
                onItemClick={handleLegendClick}
              />
            </div>
          </Show>
        </div>
        </Show>
        <Show when={mapAllOnly()}>
          <Show when={!liveTableLoadSettled()}>
            <div class="flex flex-col items-center justify-center w-full min-h-[40vh] px-4 text-gray-600">
              <p class="text-lg font-medium">Loading live maneuvers…</p>
            </div>
          </Show>
          <Show when={liveTableLoadSettled() && !hasManeuvers()} fallback={null}>
            <div class="flex flex-col items-center justify-center w-full min-h-[40vh] px-4 text-gray-600">
              <p class="text-lg font-medium">No live maneuvers yet</p>
              <p class="text-sm mt-2 text-center max-w-md">
                {streamingStatusStore.status()().isLiveDatasetVisible
                  ? `Waiting for maneuvers from the live pipeline, or none detected yet for ${getLiveManeuverQueryDateYmd()}. New rows appear automatically every few seconds.`
                  : 'Enable live processing or start streaming/simulation in Admin → Streaming. LIVE dataset rows appear when a live session is active.'}
              </p>
            </div>
          </Show>
          <Show when={hasManeuvers() && !hasFilteredManeuvers()}>
            <div class="flex items-center justify-center h-[calc(100vh-120px)]">
              <div class="text-center">
                <p class="text-xl text-gray-600">No maneuvers found</p>
                <p class="text-sm text-gray-500 mt-1">No matching maneuvers for the default live filters.</p>
              </div>
            </div>
          </Show>
          <Show when={hasFilteredManeuvers()}>
            <div id="live-maneuvers-all-grid" class="live-maneuvers-all-grid">
              <For each={[...LIVE_ALL_GRID_MANEUVER_TYPES]}>
                {(gridType) => (
                  <div class="live-maneuvers-all-cell">
                    <div class="live-maneuvers-all-cell-label">{gridType}</div>
                    <div class="live-maneuvers-all-cell-map">
                      <ManeuverMap
                        context={context}
                        instanceId={`live-all-${gridType.toLowerCase()}`}
                        maneuverEventType={gridType}
                        eventList={liveAllGridData()?.[gridType]?.eventIds ?? []}
                        tableRows={liveAllGridData()?.[gridType]?.rows ?? []}
                        compact
                        panelActive={() => mapAllOnly()}
                        onLoadStateChange={(loading) => handleMapAllCellLoadState(gridType, loading)}
                      />
                    </div>
                  </div>
                )}
              </For>
            </div>
          </Show>
        </Show>
        <Show when={!mapAllOnly()}>
        <Show when={!liveTableLoadSettled()}>
          <div class="flex flex-col items-center justify-center w-full min-h-[40vh] px-4 text-gray-600">
            <p class="text-lg font-medium">Loading live maneuvers…</p>
            <p class="text-sm mt-2 text-center max-w-md">
              Fetching maneuvers for {getLiveManeuverQueryDateYmd()} (LIVE datasets).
            </p>
          </div>
        </Show>
        {/* Content section: empty state when no data, then filter-too-strict or views */}
        <Show when={liveTableLoadSettled() && !hasManeuvers()} fallback={null}>
          <div class="flex flex-col items-center justify-center w-full min-h-[40vh] px-4 text-gray-600">
            <p class="text-lg font-medium">No live maneuvers yet</p>
            <p class="text-sm mt-2 text-center max-w-md">
              {streamingStatusStore.status()().isLiveDatasetVisible
                ? `Waiting for maneuvers from the live pipeline, or none detected yet for ${getLiveManeuverQueryDateYmd()}. New rows appear automatically every few seconds.`
                : 'Enable live processing or start streaming/simulation in Admin → Streaming. LIVE dataset rows appear when a live session is active.'}
            </p>
          </div>
        </Show>
        <Show when={hasManeuvers() && !hasFilteredManeuvers()}>
          <div class="flex items-center justify-center h-[calc(100vh-200px)]">
            <div class="text-center">
              <p class="text-xl text-gray-600">No maneuvers found</p>
              <p class="text-sm text-gray-500 mt-1">Filtering criteria may be too strict, check your settings...</p>
            </div>
          </div>
        </Show>
        <Show when={hasFilteredManeuvers()}>
          <Show when={showSoloViewPanel('MAP')}>
            <div
              id="maneuver-map-layout"
              class="maneuver-map-layout flex w-full"
              classList={{
                'live-maneuver-solo-view-panel--hidden': soloViewPanelHidden('MAP'),
                'maneuver-map-layout--chart-panel': mapSidePanel() === 'CHART',
              }}
            >
              <div id="table-area">
                <Show when={!grouped()}>
                  <Show when={mapSidePanel() === 'TABLE'}>
                    <DataTable_Small context={context} />
                    <Show when={highlightedEventIds().length > 0}>
                      <div class="flex justify-start mt-2">
                        <button
                          class="btn"
                          type="button"
                          onClick={() => setMapSidePanel('CHART')}
                        >
                          Show Timeseries →
                        </button>
                      </div>
                    </Show>
                  </Show>
                  <Show when={mapSidePanel() === 'CHART'}>
                    <div style={{ height: "100%", display: "flex", "flex-direction": "column", "min-height": "0" }}>
                      <div style={{ flex: "0 0 auto", "min-height": "0" }}>
                        <TimeSeries
                          context={context}
                          selectedOnly
                          playhead
                          fitParent
                          panelActive={mapSidePanelChartActive}
                        />
                      </div>
                      <div class="flex justify-start" style={{ "flex-shrink": "0", "margin-top": `${MAP_SIDE_PANEL_EXTRA_HEIGHT_PX + MAP_SIDE_PANEL_BUTTON_GAP_PX}px` }}>
                        <button class="btn" type="button" onClick={() => setMapSidePanel('TABLE')}>
                          ← Show Data Table
                        </button>
                      </div>
                    </div>
                  </Show>
                </Show>
                <Show when={grouped()}>
                  <DataTable_SmallGrouped context={context} />
                </Show>
              </div>
              <div id="map-area">
                <Show when={!grouped()}>
                  <ManeuverMap context={context} {...livePanelProps('MAP')} />
                </Show>
                <Show when={grouped()}>
                  <MapGrouped context={context} {...livePanelProps('MAP')} />
                </Show>
              </div>
            </div>
          </Show>
          <Show when={showSoloViewPanel('SCATTER')}>
            <div
              id="scatter-area"
              classList={{ 'live-maneuver-solo-view-panel--hidden': soloViewPanelHidden('SCATTER') }}
            >
              <Show when={!grouped()}>
                <Scatter context={context} />
              </Show>
              <Show when={grouped()}>
                <ScatterGrouped context={context} />
              </Show>
            </div>
          </Show>
          <Show when={showSoloViewPanel('TIME SERIES')}>
            <div
              id="timeseries-area"
              classList={{ 'live-maneuver-solo-view-panel--hidden': soloViewPanelHidden('TIME SERIES') }}
            >
              <Show when={!grouped()}>
                <TimeSeries
                  context={context}
                  onDataUpdate={() => {
                    pauseLiveInteraction('timeseries-grade-update');
                    void fetchTableData();
                  }}
                  {...livePanelProps('TIME SERIES')}
                />
              </Show>
              <Show when={grouped()}>
                <TimeSeriesGrouped
                  context={context}
                  onDataUpdate={() => {
                    pauseLiveInteraction('timeseries-grade-update');
                    void fetchTableData();
                  }}
                  {...livePanelProps('TIME SERIES')}
                />
              </Show>
            </div>
          </Show>
          <Show when={showSoloViewPanel('TABLE')}>
            <div
              id="datatable-big-wrapper"
              classList={{ 'live-maneuver-solo-view-panel--hidden': soloViewPanelHidden('TABLE') }}
            >
              <Show when={!grouped()}>
                <DataTable_Big context={context} getRowClass={liveManeuverRowClass} />
              </Show>
              <Show when={grouped()}>
                <DataTable_BigGrouped context={context} />
              </Show>
            </div>
          </Show>
        </Show>
        </Show>
      </div>
    </div>
  );
}
